import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost, httpDelete } from "../../services/httpService";
import { toGatewaySafeBody } from "../../utils/gatewaySafeText";
import {
  getPatientListUrl,
  addNewPatientUrl,
  addNewPatientMatchUrl,
  getAppointmentsByPatientIdUrl,
  getPaymentAnalyticsByPatientIdUrl,
  generateAiTemplateUrl,
  saveAiTemplateUrl,
  generateSummaryUrl,
  addPatientVitalsUrl,
  getPatientVitalsUrl,
  generateReferalLetterUrl,
  addPatientAllergiesUrl,
  getPatientAllergiesUrl,
  addPatientConditionRelatedUrl,
  getPatientConditionRelatedUrl,
  getPatientMedicationUrl,
  addPatientMedicationUrl,
  getUsersAvailabilityByPharmacyIdUrl,
  savePatientAppointmentUrl,
  getPatientByKeywordUrl,
  updateConsultationActionsUrl,
  addPatientConsultationUrl,
  addupdateConsultationSummaryUrl,
  updatePatientDetailsUrl,
  getPatientConsultationsUrl,
  getGeneralsUrl,
  generateDemDxAssessmentsUrl,
  getPatientByPatientIdUrl,
  importPatientFromTitanUrl,
  SaveDemDxLogsAndSummaryUrl,
  saveAIChatMessageUrl,
  GetPatientVitalsSummaryByPatientIdUrl,
  updateConsultationStatusUrl,
  addConsultationTemplateUrl,
  updateConsultationTemplateUrl,
  addPatientConsultationNotes,
  updatePatientVitalsUrl,
  addConsultationFeedbackUrl,
  deletePatientAllergiesUrl,
  deletePatientConditionRelatedUrl,
  deletePatientMedicationsUrl,
  addUpdatedTranscriptionUrl,
  addPatientConsentUrl,
  addDeepGramTranscriptionUrl,
  GetPatientConsultationCountByCompanyIdUrl,
  getAddressInformationUrl,
  generateAiServiceTemplateUrl,
  updateConsultationButtonStatusUrl,
  updateConsentObtainedUrl,
  generatePreConsultAiServiceTemplateUrl,
  getConsultationAuditTimelineUrl,
  getDoctorsBySearchUrl,
  searchSurgeryUrl,
  addPatientDocumentUrl,
  getPatientDocumentsUrl,
  getPatientConsultationByConsultationIdUrl,
  deleteConsultationActionUrl,
  renamePatientDocumentUrl,
  emailPatientDocuments,
  deletePatientDocumentUrl,
  getPatientDocumentByIdUrl,
  getPatientVitalsChartsUrl,
  getPatientPrescriptionsByPatientIdUrl,
  getPatientActiveConsultationUrl,
  getAllDocumentsByEmailUrl,
  updateEventStatusUrl,
  getCompanyTagsByCompanyIdUrl,
  addCompanyTagsUrl,
  deleteCompanyTagsUrl,
  getPatientByDemoGraphicsUrl,
  getPatientByNhsNumberUrl,
  trackServiceBillingUrl,
  SummarizeConsultationSammariesUrl,
  getSendPatientQuestionnairesUrl,
  getPatientQuestionnairesByPatientyIdUrl,
  checkAndAddConsultation,
  startConsultationFromQuestionnaireUrl,
  getPatientsListUrl,
  SummarizeConsultationsActionsUrl,
  mergePatientDetailsUrl,
  getPreConsultationByConsultationIdUrl,
  getPatientConsultationCountByPatientIdUrl,
  importMultipleFromTitanUrl,
  getPatientsListV2Url,
  getPaymentAuditByConsultationUrl,
  getPatientConsentSignatureUrl,
  getReferalLetterByFilePathUrl,
  getPatientDocumentsByConsultationUrl,
  sendMessageToMeshUrl,
  getPatientVaccinationByPatientIdUrl,
  updatePatientEthnicityUrl,
  generateVideoUploadUrlUrl,
  getAllDestinationsUrl,
  getTravelOutbreaksUrl,
  deletePrescriptionDraftUrl,
  updateTaskActionStatusUrl,
  getSurgeryByIdUrl,
  getGpConnectAccessRecordStructuredUrl,
  parseAbpmReportUrl,
  updatePatientSurgeryUrl,
  addNhsServiceClaimUrl,
} from "../../apiUrls/apiUrls";
import dayjs from "dayjs";
import { calculateAge } from "../../utils/calculateAge";
import { stripAiTemplateUserControlIds } from "../../utils/stripAiTemplateUserControlIds";
import { toPatientVitalsRequest } from "../../utils/toPatientVitalsRequest";
import { ConsultationButtonStatus } from "../../enum/ConsultationButtonStatus";

const initialState = {
  isPatientDetailsLoading: false,
  isPatientDashboard: false,
  hasPreConsultTab: false,
  selectedPatient: "",
  selectedPatientDetails: null,
  patientList: [],
  mappedPatients: [],
  patientListLoader: false,
  addPatientLoader: false,
  isConsultationTab: false,
  consultationStarted: false,
  consultationEnded: false,
  currentPatientDashboardTab: "patient-overview-wrapper",
  patientAppointmentList: [],
  patientAppointmentListLoader: false,
  paymentAnalytics: [],
  paymentAnalyticsLoader: false,
  openAddTemplate: false,
  aiTemplate: [],
  aiTemplateLoader: false,
  showStartConsultationModal: false,
  showConsultationTypeModal: false,
  showPrescriptionPreviewModal: false,
  prescriptionImageBase64: "",
  showVaccinationPreviewModal: false,
  showVaccineConfirmationModal: false,
  vaccinationImageBase64: "",
  patientSummary: null,
  patientSummaryLoader: false,
  patientTranscription: "",
  patientTabSwitcher: 0,
  showAddVitalsModal: false,
  addPatientVitalsLoader: false,
  patientVitals: null,
  patientVitalsLoading: false,
  patientSummaryArray: [],
  patientCurrentSummaryArray: null,
  selectedPatientId: "",
  selectedPharmacyId: "",
  isSummaryGenerated: false,
  referralLetter: "",
  referralLetterLoader: false,
  chatBotReferralLetter: "",
  firstPatientPanelTitle: null,
  togglePatientPanelOne: false,
  secondPatientPanelTitle: null,
  togglePatientPanelTwo: false,
  addPatientAllergiesLoader: false,
  showAddAllergiessModal: false,
  patientAllergiesLoading: false,
  patientCondtionRelatedLoading: false,
  patientMedicationsLoading: false,
  showAddConditionRelatedModal: false,
  showAddMedicationsModal: false,
  addPatientConditionRelatedLoader: false,
  addPatientMedicationsLoader: false,
  patientAllergies: [],
  patientConditionRelated: [],
  patientMedications: [],
  patientChatAnswersLoader: false,
  patientAIChatMessages: [],
  usersAvailability: [],
  usersAvailabilityLoader: false,
  templateStructure: "",
  filteredPatients: [],
  filteredPatientsLoader: [],
  updateConsultationActionsLoader: false,
  deleteConsultationActionLoader: false,
  deletePrescriptionDraftLoader: false,
  addPatientConsultationLoader: false,
  addPatientConsultation: null,
  addConsultationSummaryLoader: false,
  consultationId: "",
  companyData: [],
  isCompanyLoading: false,
  prescriptionCompleted: false,
  paymentCompleted: false,
  referralCompleted: false,
  bookingCompleted: false,
  vitalsCompleted: false,
  vaccineCompleted: false,
  documentCompleted: false,
  signatureCompleted: false,
  showPatientDetailsEditModal: false,
  showPreviousConsultationsModal: false,
  isChatReferralLetter: false,
  chatQuestions: "",
  patientConsultations: null,
  showPatientConsultationsLoader: false,
  prevConsultationsDetailData: [],
  patientPrescriptionConsultation: [],
  patientForm: false,
  newPatientFormDefaults: null,
  showNoPatientCard: true,
  selectedPatientConsultation: null,
  isConsultationEnabled: false,
  searchedSurgeries: [],
  searchedSurgeriesLoading: false,
  isDemDXTemplatesLoading: false,
  demDXTemplates: null,
  isDemDXTemplate: null,
  showPatientReferralLetterModal: false,
  isSummaryStreaming: false,
  showPatientPrescriptionModal: false,
  patientPrescription: {},
  showEditAiTemplateModal: false,
  templateForEditModal: null,
  selectedTemplateName: "",
  isDemDXGlobalCheck: false,
  demDxSummary: "",
  isDemDxActive: false,
  demDXForChat: false,
  isSummaryEnabled: true,
  demDXPatient: null,
  importPatientFromTitanLoader: false,
  importedPatientFromTitan: null,
  saveAIChatMessageDataLoader: false,
  isAIChatMessageSaved: false,
  patientVitalsSummary: [],
  updatePatientDetailsLoader: false,
  updateConsultationStatusLoader: false,
  addConsultationTemplateLoader: false,
  updateConsultationSummaryLoader: false,
  isCallStarted: false,
  isFinalSummary: true,
  patientNotes: "",
  isEditMode: false,
  vitalToEdit: null,
  vitalType: null,
  vitalMessageId: null,
  deletePatientVitalsLoader: false,
  showDeleteVitalsModal: false,
  vitalToDelete: null,
  consultationFeedbackLoader: false,
  deletePatientAllergiesLoader: false,
  selectedPatientAllergy: null,
  isAllergiesEditMode: false,
  deletePatientConditionRelatedLoader: false,
  selectedPatientConditionRelated: null,
  isConditionRelatedEditMode: false,
  deletePatientMedicationsLoader: false,
  selectedPatientMedications: null,
  isMedicationsEditMode: false,
  consultationMediaButtonMode: "transcription",
  demDxSummaryText: "",
  PatientNotes: "",
  isNotesExpanded: false,
  consultationTranscriptionLoader: false,
  transcript: "",
  showPlayPauseBtn: false,
  signatureDialog: {
    open: false,
    viewMode: false,
    details: null,
  },
  signatureDetails: null,
  consultationPaused: false,
  deepGramTranscription: null,
  consultationStopAfterRefresh: false,
  freeTypeMode: false,
  updateConsultationButtonLoader: false,
  isLocallyCompleted: false,
  isPatientConsultaionCountLoading: false,
  patientConsultaionCountData: [],
  showAddPatientModal: false,
  addressSearchResults: [],
  addressSearchLoading: false,
  serviceSummary: "",
  serviceSummaryLoading: false,
  isPreConsultServiceSummaryLoading: false,
  preConsultServiceSummary: "",
  isServiceAppointmentsLoading: false,
  preConsultationTemplate: null,
  consultationAuditTimeline: null,
  auditTimelineLoader: false,
  preConsultationTranscription: null,
  preConsultAddtoSummary: true,
  searchedDoctor: "",
  patientDocuments: [],
  patientDocumentsLoader: false,
  patientDocumentDetails: null,
  patientDocumentDetailsLoader: false,
  patientVitalsChart: [],
  consultationData: null,
  vitalsDetails: null,
  vaccineDetails: null,
  openVaccineDialog: false,
  bookingDetails: null,
  openBookingDialog: false,
  appointmentMessageId: null,
  openRefDialog: false,
  letterDetails: null,
  patientPrescriptions: [],
  patientPrescriptionsLoader: false,
  isHandleStartConsultation: false,
  hasPreConsult: false,
  openPrescriptionDialog: false,
  prescriptionDetails: null,
  dynamicPrescriptions: [
    {
      id: Date.now(),
      value: "",
      quantity: "",
      dose: "",
      notes: "",
      prescribedItemId: "",
    },
  ],
  prescriptionId: "",
  isPrescriptionUpdate: false,
  selectedPrescriptionCategory: "private",
  showActivePatientConsultationsLoader: false,
  patientActiveConsultation: [],
  updateEventStatusLoader: false,
  quickActionsTabSwitch: 0,
  allDocuments: [],
  allDocumentsLoader: false,
  isCompanyTagsLoading: false,
  companyTags: null,
  selectedCompanyTags: [],
  patientDemoGraphicsloader: false,
  isServiceBillingLoading: false,
  consultationPoints: "",
  isConsultationPointsLoading: false,
  selectedConsultation: null,
  isConsultationSummaryLoading: false,
  patientSummaryForActions: null,
  isSendPatientQuestionnairesLoading: false,
  isGetPatientQuestionnairesLoading: false,
  patientQuestionnaires: [],
  isConsultationAddedLoading: false,
  isStartConsultationFromQuestionnaireLoading: false,
  mergePatientDetailsLoader: false,
  mergePatientDetailsRes: null,
  preConsultData: null,
  ispreConsultDataLoading: false,
  preConsultImagePreview: "",
  showPreConsultImagePreviewModal: false,
  patientConsultationCount: null,
  patientConsultationCountLoading: false,
  isImportMultipleFromTitanLoading: false,
  patientsListV2: null,
  patientsListV2Loader: false,
  summaryDocumentId: null,
  comingFromPatientListView: false,
  paymentAuditData: null,
  isPaymentAuditDataLoading: false,
  isgetPatientConsentSignatureLoading: false,
  patientConsentSignature: "",
  patientReferalLetter: null,
  isSummaryLetterLoading: false,
  patientDocumentsConultaion: [],
  ConsultationQuestionnaireData: null,
  nhs111FormData: null,
  nhs111Prescriptions: null,
  nhs111EmergencySupplyMedications: null,
  consultationServiceCode: null,
  patientVaccinations: null,
  isPatientVaccinationsLoading: false,
  showMultipleVaccineCertificatePreview: false,
  multipleVaccinationImage: null,
  viewOpen: false,
  isManualSubmited: false,
  isImageDocUploaded: false,
  imageDocDetails: null,
  generatedVaccinationCertificate: null,
  travelDestinations: [],
  isTravelDestinationsLoading: false,
  isTreatmenPlanCreated: false,
  treatmentPlanDetails: null,
  patientActiveTreatmentPlans: [],
  ispatientActiveTreatmentPlans: false,
  travelOutbreaks: [],
  isTravelOutbreaksLoading: false,
  showReferralLetterDialog: false,
  isTaskStatusUpdated: false,
  snomedCodes: [],
  nhsContraceptionFormData: null,
  nhsSinusitisFormData: null,
  nhsUtiFormData: null,
  nhsSoreThroatFormData: null,
  nhsImpetigoFormData: null,
  nhsInsectBitesFormData: null,
  nhsShinglesFormData: null,
  nhsAomFormData: null,
  nhsAhtFormData: null,
  showPathwayCompletionModal: false,
  pendingCalculatorId: null,
  hypertensionInitialFormData: null,
  hypertensionABPMFittingFormData: null,
  hypertensionABPMFollowupFormData: null,
  isSurgeryLoading: false,
  surgeryData: null,
  isConsultationDataLoading: true,
  isAccessRecordLoading: false,
  accessRecordData: null,
  isParseAbpmReportLoading: false,
  abpmReadings: null,
  isUpdatePatientSurgeryLoading: false,
  updatePatientSurgeryRes: null,
  isAddNhsServiceClaimLoading: false,
  addNhsServiceClaimRes: null,
  completedTasksByConsultation: {},
};

export const getPatientListData = createAsyncThunk(
  "patient/getPatientListData",
  async (params, thunkApi) => {
    const { pharmacyId } = params;
    const urlToGet = getPatientListUrl(pharmacyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

// The patient-details schema only accepts the numeric MedicalTherapyLevel (0-4).
// Medications loaded from the API carry the enum name (e.g. "Acute"), so map
// names and numeric strings back to numbers before posting.
const THERAPY_LEVEL_VALUES = {
  none: 0,
  chronic: 1,
  acute: 2,
  maintenance: 3,
  asneeded: 4,
};

export const toTherapyLevelNumber = (therapyLevel) => {
  if (
    therapyLevel === null ||
    therapyLevel === undefined ||
    therapyLevel === ""
  ) {
    return null;
  }
  if (typeof therapyLevel === "number") {
    return therapyLevel;
  }
  const text = String(therapyLevel).trim();
  if (/^[0-4]$/.test(text)) {
    return Number(text);
  }
  return (
    THERAPY_LEVEL_VALUES[text.toLowerCase().replace(/[\s_-]/g, "")] ?? null
  );
};

// times/preparation are FE-only; the Medications schema doesn't accept them.
const normalizePatientMedications = (data) =>
  Array.isArray(data?.medications)
    ? {
        ...data,
        medications: data.medications.map(
          ({ times, preparation, ...medication }) => ({
            ...medication,
            therapyLevel: toTherapyLevelNumber(medication?.therapyLevel),
          }),
        ),
      }
    : data;

// List items (allergies, medications, contacts, ...) carry a FE-only `id` used as
// a React key. RelationShips is the only item schema with an Id, so keep it there.
const ARRAYS_WITH_ID = new Set(["relationships"]);

const stripArrayItemIds = (data) =>
  data && typeof data === "object"
    ? Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          Array.isArray(value) && !ARRAYS_WITH_ID.has(key)
            ? value.map((item) => {
                if (!item || typeof item !== "object") return item;
                const { id, ...rest } = item;
                return rest;
              })
            : value,
        ]),
      )
    : data;

const toPatientDetailsRequest = (data) =>
  stripArrayItemIds(normalizePatientMedications(data));

export const addNewPatientData = createAsyncThunk(
  "patient/addNewPatientData",
  async (data, thunkApi) => {
    const url = addNewPatientUrl(data);
    const respData = await httpPost(url, toPatientDetailsRequest(data));
    return respData;
  },
);
export const addNewPatientMatchData = createAsyncThunk(
  "patient/addNewPatientMatchData",
  async (data, thunkApi) => {
    const url = addNewPatientMatchUrl(data);
    const respData = await httpPost(url, toPatientDetailsRequest(data));
    return respData;
  },
);
export const getPatientAppointmentsByIdData = createAsyncThunk(
  "patient/getPatientAppointmentsByIdData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(getAppointmentsByPatientIdUrl(patientId));
    return respData;
  },
);

export const getPaymentAnalyticsByPatientIdData = createAsyncThunk(
  "patient/getPaymentAnalyticsByPatientIdData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(
      getPaymentAnalyticsByPatientIdUrl(patientId),
    );
    return respData;
  },
);

export const generateAiTemplateData = createAsyncThunk(
  "patient/generateAiTemplateData",
  async (data, thunkApi) => {
    const respData = await httpPost(generateAiTemplateUrl(), data);
    return respData;
  },
);

export const saveAiTemplateData = createAsyncThunk(
  "patient/saveAiTemplateData",
  async (data, thunkAPI) => {
    const respData = await httpPost(
      saveAiTemplateUrl(),
      stripAiTemplateUserControlIds(data),
    );
    return respData;
  },
);
export const generatePatientSummaryData = createAsyncThunk(
  "patient/generatePatientSummaryData",
  async (data, thunkApi) => {
    const respData = await httpPost(generateSummaryUrl(), data);
    return respData;
  },
);

export const addPatientVitalsData = createAsyncThunk(
  "patient/addPatientVitalsData",
  async (data, thunkApi) => {
    const url = addPatientVitalsUrl(data);
    const respData = await httpPost(url, toPatientVitalsRequest(data));
    return respData;
  },
);

export const getPatientVitalsData = createAsyncThunk(
  "patient/getPatientVitalsData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(getPatientVitalsUrl(patientId));
    return respData;
  },
);
export const generateReferalLetterData = createAsyncThunk(
  "patient/generateReferalLetterData",
  async (data, thunkApi) => {
    const respData = await httpPost(generateReferalLetterUrl(), data);
    return respData;
  },
);
export const addPatientAllergiesData = createAsyncThunk(
  "patient/addPatientAllergiesData",
  async (data, thunkApi) => {
    const url = addPatientAllergiesUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientAllergiesData = createAsyncThunk(
  "patient/getPatientAllergiesData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(getPatientAllergiesUrl(patientId));
    return respData;
  },
);

export const getPatientConditionRelatedData = createAsyncThunk(
  "patient/getPatientConditionRelatedData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(getPatientConditionRelatedUrl(patientId));
    return respData;
  },
);
export const addPatientCondtionRelatedData = createAsyncThunk(
  "patient/addPatientCondtionRelatedData",
  async (data, thunkApi) => {
    const url = addPatientConditionRelatedUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientMedicationsData = createAsyncThunk(
  "patient/getPatientMedicationsData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(getPatientMedicationUrl(patientId));
    return respData;
  },
);

export const addPatientMedicationsData = createAsyncThunk(
  "patient/addPatientMedicationsData",
  async (data, thunkApi) => {
    const url = addPatientMedicationUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const updatePatientSurgeryData = createAsyncThunk(
  "patient/updatePatientSurgeryData",
  async (data, thunkApi) => {
    const url = updatePatientSurgeryUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getAppointmentsByPharmacyIdData = createAsyncThunk(
  "patient/getAppointmentsByPharmacyIdData",
  async (params, thunkApi) => {
    const { pharmacyId } = params;
    const urlToGet = getUsersAvailabilityByPharmacyIdUrl(pharmacyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const savePatientAppointmentData = createAsyncThunk(
  "patient/savePatientAppointmentData",
  async (data, thunkApi) => {
    const url = savePatientAppointmentUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const updateConsultationActionsData = createAsyncThunk(
  "patient/updateConsultationActions",
  async (data, thunkApi) => {
    const { consultationId, payload } = data;
    const url = updateConsultationActionsUrl(consultationId);
    // performedAt is only used on the FE; the API (Actions) doesn't accept it.
    const { performedAt, ...action } = payload || {};
    const respData = await httpPost(url, action);
    return respData;
  },
);
export const updateConsultationStatusData = createAsyncThunk(
  "patient/updateConsultationStatus",
  async (data, thunkApi) => {
    const url = updateConsultationStatusUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const addConsultationTemplateData = createAsyncThunk(
  "patient/addConsultationTemplateData",
  async (data, thunkApi) => {
    const { consultationId, template } = data;
    // API schema rejects demdx_Type; it's only used for UI labels/filtering
    const { demdx_Type, ...body } = template || {};
    const url = addConsultationTemplateUrl(consultationId);
    const respData = await httpPost(url, body);
    return respData;
  },
);
export const updateConsultationTemplateData = createAsyncThunk(
  "patient/updateConsultationTemplateData",
  async (data, thunkApi) => {
    const { consultationId, payload } = data;
    const url = updateConsultationTemplateUrl(consultationId);
    const respData = await httpPost(url, toGatewaySafeBody(payload));
    return respData;
  },
);

export const addPatientConsultationData = createAsyncThunk(
  "patient/addPatientConsultationData",
  async (data, thunkApi) => {
    const url = addPatientConsultationUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const addupdateConsultationSummaryData = createAsyncThunk(
  "patient/addupdateConsultationSummaryData",
  async (data, thunkApi) => {
    const { consultationId, summary } = data;
    const url = addupdateConsultationSummaryUrl(consultationId);
    const respData = await httpPost(url, { summary: summary });
    return respData;
  },
);

export const getPatientByKeywordData = createAsyncThunk(
  "patient/getPatientByKeywordData",
  async (params, thunkApi) => {
    const { pharmacyId, keyword, companyId } = params;
    const urlToGet = getPatientByKeywordUrl(pharmacyId, keyword, companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getCompanyData = createAsyncThunk(
  "patient/getCompanyData",
  async (companyId, thunkApi) => {
    const urlToGet = getGeneralsUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getPatientConsultationsData = createAsyncThunk(
  "patient/getPatientConsultationsData",
  async (params, thunkApi) => {
    const { patientId } = params;
    const urlToGet = getPatientConsultationsUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const updatePatientDetailsData = createAsyncThunk(
  "patient/updatePatientDetailsData",
  async (params) => {
    const url = updatePatientDetailsUrl();
    // Allergies/Medications/RelatedCondition schemas have no Id; the FE `id` is only a React key.
    const body = { ...normalizePatientMedications(params) };
    ["allergies", "conditionRelated", "medications"].forEach((key) => {
      if (Array.isArray(body?.[key])) {
        body[key] = body[key].map((item) => {
          if (!item || typeof item !== "object") return item;
          const { id, ...rest } = item;
          return rest;
        });
      }
    });
    // The API returns importedOn without an offset ("0001-01-01T00:00:00"),
    // but the request schema requires one, so mark it as UTC.
    if (
      typeof body.importedOn === "string" &&
      !/(Z|[+-]\d{2}:\d{2})$/.test(body.importedOn)
    ) {
      body.importedOn = `${body.importedOn}Z`;
    }
    const respData = await httpPost(url, body);
    return respData;
  },
);

export const generateDemDXAssessmentsData = createAsyncThunk(
  "patient/generateDemDXAssessmentsData",
  async (data, thunkApi) => {
    const url = generateDemDxAssessmentsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const getPatientByPatientIdData = createAsyncThunk(
  "patient/getPatientByPatientIdData",
  async (patientId, thunkApi) => {
    const urlToGet = getPatientByPatientIdUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const importPatientFromTitanData = createAsyncThunk(
  "patient/importPatientFromTitanData",
  async (data, thunkApi) => {
    const url = importPatientFromTitanUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const SaveDemDxLogsAndSummaryData = createAsyncThunk(
  "patient/SaveDemDxLogsAndSummaryData",
  async (data, thunkApi) => {
    const url = SaveDemDxLogsAndSummaryUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const GetPatientVitalsSummaryByPatientIdData = createAsyncThunk(
  "patient/GetPatientVitalsSummaryByPatientIdData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(
      GetPatientVitalsSummaryByPatientIdUrl(patientId),
    );
    return respData;
  },
);

export const saveAIChatMessageData = createAsyncThunk(
  "PatientConsultation/UpdateConsultationChat",
  async (data, thunkApi) => {
    const url = saveAIChatMessageUrl();
    // Callers use ConsultationId/ConsultationChat; the API (ConsultationChatModel) expects camelCase.
    const body = {
      consultationId: data?.consultationId ?? data?.ConsultationId,
      consultationChat: data?.consultationChat ?? data?.ConsultationChat,
    };
    const respData = await httpPost(url, body);
    return respData;
  },
);

export const addPatientConsultationNotesData = createAsyncThunk(
  "PatientConsultation/addPatientConsultationNotesData",
  async (data, thunkApi) => {
    const url = addPatientConsultationNotes();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const updatePatientVitalsData = createAsyncThunk(
  "patient/updatePatientVitalsData",
  async (data, thunkApi) => {
    const { isDelete, vitalsModal } = data;
    const url = updatePatientVitalsUrl(isDelete);
    const respData = await httpPost(url, vitalsModal);
    return respData;
  },
);

export const addConsultationFeedbackData = createAsyncThunk(
  "PatientConsultation/addConsultationFeedbackData",
  async (data, thunkApi) => {
    const url = addConsultationFeedbackUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const addUpdatedTranscriptionData = createAsyncThunk(
  "PatientConsultation/addUpdatedTranscriptionData",
  async (data, thunkApi) => {
    const url = addUpdatedTranscriptionUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deletePatientAllergiesData = createAsyncThunk(
  "patient/deletePatientAllergiesData",
  async (data) => {
    const url = deletePatientAllergiesUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const deletePatientConditionRelatedData = createAsyncThunk(
  "patient/deletePatientConditionRelatedData",
  async (data) => {
    const url = deletePatientConditionRelatedUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const deletePatientMedicationsData = createAsyncThunk(
  "patient/deletePatientMedicationsData",
  async (data) => {
    const url = deletePatientMedicationsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const addPatientConsentData = createAsyncThunk(
  "patient/addPatientConsentData",
  async ({ consultationId, data }) => {
    const url = addPatientConsentUrl(consultationId);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const addDeepGramTranscriptionData = createAsyncThunk(
  "patient/addDeepGramTranscriptionData",
  async (data) => {
    const url = addDeepGramTranscriptionUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const updateConsultationButtonStatusData = createAsyncThunk(
  "patient/updateConsultationButtonStatusData",
  async (data, thunkApi) => {
    const url = updateConsultationButtonStatusUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const updateConsentObtainedData = createAsyncThunk(
  "patient/updateConsentObtained",
  async (data, thunkApi) => {
    const url = updateConsentObtainedUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientConsultationsCountData = createAsyncThunk(
  "patient/getPatientConsultationsCountData",
  async (companyID, thunkApi) => {
    const urlToGet = GetPatientConsultationCountByCompanyIdUrl(companyID);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getAddressInformationUrlData = createAsyncThunk(
  "patient/getAddressInformationUrlData",
  async (data, thunkApi) => {
    const url = getAddressInformationUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const generateAiServiceTemplateData = createAsyncThunk(
  "patient/generateAiServiceTemplateData",
  async (data) => {
    const url = generateAiServiceTemplateUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const generatePreConsultAiServiceTemplateData = createAsyncThunk(
  "patient/generatePreConsultAiServiceTemplateData",
  async (data) => {
    const url = generatePreConsultAiServiceTemplateUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const getConsultationAuditTimelineData = createAsyncThunk(
  "patient/getConsultationAuditTimelineData",
  async (data) => {
    const url = getConsultationAuditTimelineUrl(data);
    const respData = await httpGet(url);
    return respData;
  },
);
export const getAllDestinationsData = createAsyncThunk(
  "patient/getAllDestinationsData",
  async (thunkApi) => {
    const url = getAllDestinationsUrl();
    const respData = await httpGet(url);
    return respData;
  },
);
export const getTravelOutbreaksData = createAsyncThunk(
  "patient/getTravelOutbreaksData",
  async (thunkApi) => {
    const url = getTravelOutbreaksUrl();
    const respData = await httpGet(url, { skipErrorPage: true });
    return respData;
  },
);
export const getDoctorsBySearchData = createAsyncThunk(
  "patient/getDoctorsBySearchData",
  async (data) => {
    const url = getDoctorsBySearchUrl(data);
    const respData = await httpGet(url);
    return respData;
  },
);

export const addPatientDocumentsData = createAsyncThunk(
  "patient/addPatientDocumentsData",
  async (data, thunkApi) => {
    const url = addPatientDocumentUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientDocumentsData = createAsyncThunk(
  "patient/getPatientDocumentsData",
  async (patientId, thunkApi) => {
    const urlToGet = getPatientDocumentsUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getPatientConsultationByConsultationIdData = createAsyncThunk(
  "patient/getPatientConsultationBuConsultationIdData",
  async (params, thunkApi) => {
    const { consultationId } = params;
    const urlToGet = getPatientConsultationByConsultationIdUrl(consultationId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const renamePatientDocumentData = createAsyncThunk(
  "patient/renamePatientDocumentData",
  async (data, thunkApi) => {
    const url = renamePatientDocumentUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const emailPatientDocumentData = createAsyncThunk(
  "patient/emailPatientDocumentData",
  async (data, thunkApi) => {
    const url = emailPatientDocuments(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deletePatientDocumentData = createAsyncThunk(
  "patient/deletePatientDocumentData",
  async (documentID, thunkApi) => {
    const url = deletePatientDocumentUrl(documentID);
    const respData = await httpDelete(url);
    return respData;
  },
);

export const getPatientDocumentByIdData = createAsyncThunk(
  "patient/getPatientDocumentByIdData",
  async (data, thunkApi) => {
    const url = getPatientDocumentByIdUrl(data);
    const respData = await httpGet(url);
    return respData;
  },
);

export const getPatientVitalsChartsData = createAsyncThunk(
  "patient/getPatientVitalsChartsData",
  async (params, thunkApi) => {
    const { patientID, vitalName } = params;
    const urlToGet = getPatientVitalsChartsUrl(patientID, vitalName);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getPatientPrescriptionsByPatientIdData = createAsyncThunk(
  "patient/getPatientPrescriptionsByPatientIdData",
  async (patientId, thunkApi) => {
    const urlToGet = getPatientPrescriptionsByPatientIdUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getPatientActiveConsultationData = createAsyncThunk(
  "patient/getPatientActiveConsultationData",
  async (params, thunkApi) => {
    const { patientId } = params;
    const urlToGet = getPatientActiveConsultationUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getAllDocumentsByEmailData = createAsyncThunk(
  "patient/getAllDocumentsByEmailData",
  async (params, thunkApi) => {
    const urlToGet = getAllDocumentsByEmailUrl();
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getCompanyTagsByCompanyIdData = createAsyncThunk(
  "patient/getCompanyTagsByCompanyIdData",
  async (companyID, thunkApi) => {
    const urlToGet = getCompanyTagsByCompanyIdUrl(companyID);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const updateEventStatusData = createAsyncThunk(
  "patient/updateEventStatusData",
  async (data, thunkApi) => {
    const url = updateEventStatusUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const addCompanyTagsData = createAsyncThunk(
  "patient/addCompanyTagsData",
  async (data, thunkApi) => {
    const url = addCompanyTagsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const deleteCompanyTagsData = createAsyncThunk(
  "patient/deleteCompanyTagsData",
  async (data, thunkApi) => {
    const url = deleteCompanyTagsUrl(data);
    const response = await httpDelete(url);
    return response?.data || response;
  },
);

export const getPatientByDemoGraphicsData = createAsyncThunk(
  "patient/getPatientByDemoGraphicsData",
  async (data, thunkApi) => {
    // pharmacyId goes in the query string only; API schema rejects it and
    // patientName in the body
    const { pharmacyId, patientName, ...body } = data;
    const urltoGet = getPatientByDemoGraphicsUrl(pharmacyId);
    const respData = await httpPost(urltoGet, body);
    return respData;
  },
);

export const getPatientByNhsNumberData = createAsyncThunk(
  "patient/getPatientByNhsNumberData",
  async (data, thunkApi) => {
    // pharmacyId goes in the query string; the body (PatientSearchByNHSNumberRequestModel)
    // only accepts nhsNumber and dateOfBirth.
    const { pharmacyId, ...body } = data;
    const urltoGet = getPatientByNhsNumberUrl(pharmacyId);
    const respData = await httpPost(urltoGet, body);
    return respData;
  },
);

export const trackServiceBillingData = createAsyncThunk(
  "patient/TrackServiceBillingData",
  async (data, thunkApi) => {
    const url = trackServiceBillingUrl();
    // Callers use companyId/actiontype; the API (BillingActionRequestModel) expects companyID/actionType.
    const { companyId, actiontype, ...rest } = data || {};
    const body = {
      ...rest,
      companyID: rest.companyID ?? companyId,
      actionType: rest.actionType ?? actiontype,
    };
    const respData = await httpPost(url, body);
    return respData;
  },
);
export const summarizeConsultationSummariesData = createAsyncThunk(
  "patient/summarizeConsultationSummariesData",
  async (data, thunkApi) => {
    const url = SummarizeConsultationSammariesUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const sendPatientQuestionnairesData = createAsyncThunk(
  "patient/sendPatientQuestionnairesData",
  async (data, thunkApi) => {
    const url = getSendPatientQuestionnairesUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const getPatientQuestionnairesByPatientyIdData = createAsyncThunk(
  "patient/getPatientQuestionnairesByPatientyIdData",
  async (patientID, thunkApi) => {
    const url = getPatientQuestionnairesByPatientyIdUrl(patientID);
    const respData = await httpGet(url);
    return respData;
  },
);
export const checkAndAddConsultationData = createAsyncThunk(
  "patient/checkAndAddConsultationData",
  async (data, thunkApi) => {
    const url = checkAndAddConsultation();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const startConsultationFromQuestionnaireData = createAsyncThunk(
  "patient/startConsultationFromQuestionnaireData",
  async (data, thunkApi) => {
    const url = startConsultationFromQuestionnaireUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientsListData = createAsyncThunk(
  "patient/getPatientsListData",
  async (params, thunkApi) => {
    const { pharmacyId } = params;
    const urlToGet = getPatientsListUrl(pharmacyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const SummarizeConsultationsActionsData = createAsyncThunk(
  "patient/SummarizeConsultationsActionsData",
  async (data, thunkApi) => {
    const url = SummarizeConsultationsActionsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const mergePatientDetailsData = createAsyncThunk(
  "patient/mergePatientDetailsData",
  async (data, thunkApi) => {
    const url = mergePatientDetailsUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const getPreConsultationByConsultationIdData = createAsyncThunk(
  "patient/getPreConsultationByConsultationIdData",
  async (params, thunkApi) => {
    const { consultationId } = params;
    const urlToGet = getPreConsultationByConsultationIdUrl(consultationId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getPatientConsultationCountByPatientIdData = createAsyncThunk(
  "patient/getPatientConsultationCountByPatientIdData",
  async (data, thunkApi) => {
    const url = getPatientConsultationCountByPatientIdUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const importMultipleFromTitanData = createAsyncThunk(
  "patient/importMultipleFromTitanData",
  async (data, thunkApi) => {
    const url = importMultipleFromTitanUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientsListV2Data = createAsyncThunk(
  "patient/getPatientsListV2Data",
  async (data, thunkApi) => {
    const url = getPatientsListV2Url();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientsListPowerSearchData = createAsyncThunk(
  "patient/getPatientsListPowerSearchData",
  async (data, thunkApi) => {
    const url = getPatientsListV2Url();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPaymentAuditByConsultationData = createAsyncThunk(
  "patient/getPaymentAuditByConsultationData",
  async (params, thunkApi) => {
    const { consultationID } = params;
    const urlToGet = getPaymentAuditByConsultationUrl(consultationID);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getPatientConsentSignatureData = createAsyncThunk(
  "patient/getPatientConsentSignatureData",
  async (data, thunkApi) => {
    const url = getPatientConsentSignatureUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const getReferalLetterByFilePathData = createAsyncThunk(
  "patient/getReferalLetterByFilePathData",
  async (params, thunkApi) => {
    const urlToGet = getReferalLetterByFilePathUrl();
    const respData = await httpPost(urlToGet, params);
    return respData;
  },
);

export const getPatientDocumentsByConsultationData = createAsyncThunk(
  "patient/getPatientDocumentsByConsultationData",
  async (consultationId, thunkApi) => {
    const urlToGet = getPatientDocumentsByConsultationUrl(consultationId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const sendMessageToMeshData = createAsyncThunk(
  "patient/sendMessageToMeshData",
  async (data, thunkApi) => {
    const url = sendMessageToMeshUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getPatientVaccinationByPatientIdData = createAsyncThunk(
  "patient/getPatientVaccinationByPatientIdData",
  async (patientId, thunkApi) => {
    const urlToGet = getPatientVaccinationByPatientIdUrl(patientId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const updatePatientEthnicityData = createAsyncThunk(
  "patient/updatePatientEthnicityData",
  async (data, thunkApi) => {
    const url = updatePatientEthnicityUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const deleteConsultationActionData = createAsyncThunk(
  "patient/deleteConsultationActionData",
  async (params, thunkApi) => {
    const { consultationID, actionNumber, vaccineName } = params;
    const url = deleteConsultationActionUrl(
      consultationID,
      actionNumber,
      vaccineName,
    );
    const respData = await httpDelete(url);
    return { ...respData, consultationID, actionNumber, vaccineName };
  },
);
export const deletePrescriptionDraftData = createAsyncThunk(
  "patient/deletePrescriptionDraftData",
  async (params, thunkApi) => {
    const { consultationID, actionNumber } = params;
    const url = deletePrescriptionDraftUrl(consultationID, actionNumber);
    const respData = await httpDelete(url);
    return { ...respData, consultationID, actionNumber };
  },
);

export const generateVideoUploadUrlData = createAsyncThunk(
  "patient/generateVideoUploadUrlData",
  async (data, thunkApi) => {
    const url = generateVideoUploadUrlUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const updateTaskActionStatusData = createAsyncThunk(
  "patient/updateTaskActionStatusData",
  async (data, thunkApi) => {
    const url = updateTaskActionStatusUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const searchSurgeryData = createAsyncThunk(
  "patient/searchSurgeryData",
  async (data, thunkApi) => {
    const url = searchSurgeryUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const getSurgeryByIdData = createAsyncThunk(
  "patient/getSurgeryByIdData",
  async (surgeryId, thunkApi) => {
    const urlToGet = getSurgeryByIdUrl(surgeryId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const accessRecordData = createAsyncThunk(
  "patient/accessRecordData",
  async ({ nhsNumber, requestingOdsCode }, thunkAPI) => {
    const urlToGet = getGpConnectAccessRecordStructuredUrl(
      nhsNumber,
      requestingOdsCode,
    );
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const parseAbpmReportData = createAsyncThunk(
  "Seeding/parseAbpmReportData",
  async (data, thunkApi) => {
    const url = parseAbpmReportUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const addNhsServiceClaimData = createAsyncThunk(
  "patient/addNhsServiceClaimData",
  async (data, thunkApi) => {
    const url = addNhsServiceClaimUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);

export const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setIsSelectedPatientData: (state, action) => {
      state.selectedPatient = action?.payload || "";
    },
    setSelectedPatientDetailsData: (state, action) => {
      state.selectedPatientDetails = action?.payload || null;

      const { title, foreName, middleName, surName } = action?.payload || {};

      state.selectedPatient = [title, foreName, middleName, surName]
        .filter((v) => v && v !== "null" && v !== "undefined")
        .join(" ");
    },
    setIsPatientDashboardData: (state, action) => {
      state.isPatientDashboard = action?.payload || false;
    },
    setIsConsultationTabData: (state, action) => {
      state.isConsultationTab = action?.payload || false;
    },
    setConsultationStartedData: (state, action) => {
      state.consultationStarted = action?.payload || false;
    },
    setConsultationEndedData: (state, action) => {
      state.consultationEnded = action?.payload || false;
    },
    setPatientDashboardTabData: (state, action) => {
      state.currentPatientDashboardTab =
        action?.payload || "patient-overview-wrapper";
    },
    setOpenAddTemplateData: (state, action) => {
      state.openAddTemplate = action?.payload || false;
    },
    setShowStartConsultationModalData: (state, action) => {
      state.showStartConsultationModal = action?.payload || false;
    },
    showConsultationTypeModalData: (state, action) => {
      state.showConsultationTypeModal = action?.payload || false;
    },
    setShowPrescriptionPreviewModalData: (state, action) => {
      state.showPrescriptionPreviewModal = action?.payload || false;
    },
    setPrescriptionImageBase64Data: (state, action) => {
      state.prescriptionImageBase64 = action?.payload || "";
    },
    setShowVaccinationPreviewModalData: (state, action) => {
      state.showVaccinationPreviewModal = action?.payload || false;
    },
    setVaccinationImageBase64Data: (state, action) => {
      state.vaccinationImageBase64 = action?.payload || "";
    },
    setShowVaccineConfirmationModalData: (state, action) => {
      state.showVaccineConfirmationModal = action?.payload || false;
    },
    setPatientTranscriptionData: (state, action) => {
      state.patientTranscription = action?.payload || "";
    },
    setPatientTabSwitcherData: (state, action) => {
      state.patientTabSwitcher = action?.payload || 0;
    },
    setShowAddVitalsModalData: (state, action) => {
      state.showAddVitalsModal = action?.payload || false;
    },
    setpatientSummaryData: (state, action) => {
      state.patientSummary = action?.payload || "";
    },
    setpatientSummaryArrayData: (state, action) => {
      state.patientSummaryArray = action?.payload || null;
    },
    setpatientCurrentSummaryArrayData: (state, action) => {
      state.patientCurrentSummaryArray = action?.payload || null;
    },
    setpatientSummaryLoaderData: (state, action) => {
      state.patientSummaryLoader = action?.payload || false;
    },
    setDemDxSummaryTextData: (state, action) => {
      state.demDxSummaryText = action?.payload || "";
    },
    setSelectedPatientIdData: (state, action) => {
      state.selectedPatientId = action?.payload || "";
    },
    setSelectedPharmacyIdData: (state, action) => {
      state.selectedPharmacyId = action?.payload || "";
    },
    setPatientAiTemplateData: (state, action) => {
      state.aiTemplate = action?.payload || [];
    },

    setIsSummaryGeneratedData: (state, action) => {
      state.isSummaryGenerated = action?.payload || false;
    },
    setReferralLetterData: (state, action) => {
      state.referralLetter = action?.payload || "";
    },
    setChatBotReferralLetterData: (state, action) => {
      state.chatBotReferralLetter = action?.payload || "";
    },
    setTogglePatientPanelOneData: (state, action) => {
      state.togglePatientPanelOne = action?.payload || false;
    },
    setFirstPatientPanelTitleData: (state, action) => {
      state.firstPatientPanelTitle = action?.payload || null;
    },
    setTogglePatientPanelTwoData: (state, action) => {
      state.togglePatientPanelTwo = action?.payload || false;
    },
    setSecondPatientPanelTitleData: (state, action) => {
      state.secondPatientPanelTitle = action?.payload || null;
    },
    setShowAddAllergiessModalData: (state, action) => {
      state.showAddAllergiessModal = action?.payload || false;
    },
    setShowAddPatientConditionModalData: (state, action) => {
      state.showAddConditionRelatedModal = action?.payload || false;
    },
    setShowAddPatientMedicationModalData: (state, action) => {
      state.showAddMedicationsModal = action?.payload || false;
    },
    setPatientChatAnswersLoaderData: (state, action) => {
      state.patientChatAnswersLoader = action?.payload || false;
    },
    setTemplateStructureData: (state, action) => {
      state.templateStructure = action?.payload || "";
    },
    setConsultationIdData: (state, action) => {
      state.consultationId = action.payload;
    },
    setIsChatReferralLetterData: (state, action) => {
      state.isChatReferralLetter = action.payload;
    },
    setChatQuestionsData: (state, action) => {
      state.chatQuestions = action.payload;
    },
    setisSummaryEnabledData: (state, action) => {
      state.isSummaryEnabled = action.payload;
    },
    setIsShowPatientConsultationsLoader: (state, action) => {
      state.showPatientConsultationsLoader = action.payload;
    },
    setPreConsultImagePreviewData: (state, action) => {
      state.preConsultImagePreview = action?.payload || "";
    },
    setShowPreConsultImagePreviewModalData: (state, action) => {
      state.showPreConsultImagePreviewModal = action?.payload || false;
    },
    setShowReferralLetterDialogData: (state, action) => {
      state.showReferralLetterDialog = action?.payload || false;
    },
    setPatientAIChatMessagesData: (state, action) => {
      const { type, message } = action.payload || {};

      switch (type) {
        case "append":
          state.patientAIChatMessages = [
            ...(state.patientAIChatMessages || []),
            message,
          ];
          break;

        case "updateLast":
          if (state.patientAIChatMessages?.length > 0) {
            const updated = [...state.patientAIChatMessages];
            updated[updated.length - 1] = message;
            state.patientAIChatMessages = updated;
          }
          break;

        default:
          state.patientAIChatMessages = action.payload || [];
          break;
      }
    },
    incrementPrescriptionCompleted: (state, action) => {
      state.prescriptionCompleted = action.payload;
    },
    incrementPaymentCompleted: (state, action) => {
      state.paymentCompleted = action.payload;
    },
    incrementReferralCompleted: (state, action) => {
      state.referralCompleted = action?.payload;
    },
    incrementBookingCompleted: (state, action) => {
      state.bookingCompleted = action?.payload;
    },
    incrementVitalsCompleted: (state, action) => {
      state.vitalsCompleted = action?.payload;
    },
    incrementVaccineCompleted: (state, action) => {
      state.vaccineCompleted = action.payload;
    },
    incrementSignatureCompleted: (state, action) => {
      state.signatureCompleted = action.payload;
    },
    setShowPatientDetailsEditModal: (state, action) => {
      state.showPatientDetailsEditModal = action.payload;
    },
    setShowPreviousConsultationsModalData: (state, action) => {
      state.showPreviousConsultationsModal = action?.payload || false;
    },
    setPatientConsultationsData: (state, action) => {
      state.patientConsultations = action?.payload || null;
    },
    setPrevConsultationsDetailDataData: (state, action) => {
      state.prevConsultationsDetailData = action?.payload || [];
    },
    setHasPreConsultTabData: (state, action) => {
      state.hasPreConsultTab = action.payload || false;
    },
    setDemDXTemplatesData: (state, action) => {
      state.demDXTemplates = action?.payload || [];
    },
    addPatientAIChatMessage: (state, action) => {
      const msg = action.payload;

      let isDuplicate = false;

      if (msg.actionId === 4) {
        const appointmentPayload = msg.details?.payload
          ? JSON.parse(msg.details.payload)
          : msg.details;
        isDuplicate = state.patientAIChatMessages.some((existing) => {
          if (existing.actionId !== 4) return false;
          const existingPayload = existing.details?.payload
            ? JSON.parse(existing.details.payload)
            : existing.details;
          return (
            existingPayload?.startDate === appointmentPayload?.startDate &&
            existingPayload?.patientID === appointmentPayload?.patientID
          );
        });
      } else if (msg.actionId === 5) {
        const vitalPayload = msg.details?.payload
          ? JSON.parse(msg.details.payload)
          : msg.details;
        const vitalType = vitalPayload?.vitalsDetails?.recordedVitalType;
        const vitalMessageId = msg.vitalMessageId;
        const vitalValues = JSON.stringify(vitalPayload?.vitalsDetails);

        isDuplicate = state.patientAIChatMessages.some((existing) => {
          if (existing.actionId !== 5) return false;

          // If we have a unique message ID, use it for duplicate detection.
          if (vitalMessageId && existing.vitalMessageId) {
            return existing.vitalMessageId === vitalMessageId;
          }

          const existingPayload = existing.details?.payload
            ? JSON.parse(existing.details.payload)
            : existing.details;
          const existingVitalType =
            existingPayload?.vitalsDetails?.recordedVitalType;
          const existingVitalValues = JSON.stringify(
            existingPayload?.vitalsDetails,
          );
          return (
            existingVitalType === vitalType &&
            existingVitalValues === vitalValues
          );
        });
      } else if (msg.actionId === 15) {
        const getPlanId = (m) => {
          try {
            const d = m.details;
            if (!d) return null;
            if (d.treatmentPlanId) return d.treatmentPlanId;
            if (d.payload) {
              const p = JSON.parse(d.payload);
              return (
                p?.treatmentPlanId || p?.treatmentPlan?.treatmentPlanId || null
              );
            }
          } catch {
            return null;
          }
          return null;
        };
        const newPlanId = getPlanId(msg);
        if (newPlanId) {
          isDuplicate = state.patientAIChatMessages.some(
            (existing) =>
              existing.actionId === 15 && getPlanId(existing) === newPlanId,
          );
        }
      }

      if (!isDuplicate) {
        state.patientAIChatMessages.push(action.payload);
      }
    },
    updateVitalAIChatMessage: (state, action) => {
      const newMessage = action.payload;
      const existingIndex = state.patientAIChatMessages.findIndex((msg) => {
        if (msg.actionId === 5) {
          if (newMessage.vitalMessageId && msg.vitalMessageId) {
            const match = msg.vitalMessageId === newMessage.vitalMessageId;
            return match;
          }

          try {
            const msgPayload = JSON.parse(msg.details?.payload || "{}");
            const newPayload = JSON.parse(newMessage.details?.payload || "{}");
            const msgVitalType = msgPayload?.vitalsDetails?.recordedVitalType;
            const newVitalType = newPayload?.vitalsDetails?.recordedVitalType;
            const match =
              msgVitalType === newVitalType && msgVitalType && newVitalType;
            return match;
          } catch (e) {
            return false;
          }
        }
        return false;
      });

      if (existingIndex !== -1) {
        state.patientAIChatMessages[existingIndex] = newMessage;
      } else {
        state.patientAIChatMessages.push(newMessage);
      }
    },
    updateAppointmentAIChatMessage: (state, action) => {
      const newMessage = action.payload;

      let newConsultationId = null;
      try {
        const newPayload =
          typeof newMessage.details?.payload === "string"
            ? JSON.parse(newMessage.details.payload)
            : newMessage.details?.payload;
        newConsultationId = newPayload?.consultationID;
      } catch (e) {}

      if (newConsultationId) {
        const existingIndex = state.patientAIChatMessages.findIndex((msg) => {
          if (msg.actionId !== 4) return false;

          try {
            const existingPayload =
              typeof msg.details?.payload === "string"
                ? JSON.parse(msg.details.payload)
                : msg.details?.payload;

            return existingPayload?.consultationID === newConsultationId;
          } catch (e) {
            return false;
          }
        });

        if (existingIndex !== -1) {
          state.patientAIChatMessages[existingIndex] = newMessage;
          return;
        }
      }

      state.patientAIChatMessages.push(newMessage);
    },
    setAiChatSuccessMessagesData: (state) => {
      state.prescriptionCompleted = false;
      state.paymentCompleted = false;
      state.referralCompleted = false;
      state.bookingCompleted = false;
      state.vitalsCompleted = false;
      state.vaccineCompleted = false;
      state.signatureCompleted = false;
      state.isImageDocUploaded = false;
      state.isTreatmenPlanCreated = false;
    },
    setOpenPatientForm: (state, action) => {
      state.patientForm = action?.payload || false;
    },
    setNewPatientFormDefaultsData: (state, action) => {
      state.newPatientFormDefaults = action?.payload || null;
    },
    setShowNoPatientCardData: (state, action) => {
      state.showNoPatientCard = action?.payload || false;
    },
    setSelectedPatientConsultationData: (state, action) => {
      state.selectedPatientConsultation = action?.payload;
    },
    setIsConsultationEnabledData: (state, action) => {
      state.isConsultationEnabled = action?.payload || false;
    },
    setIsDemDXTemplateData: (state, action) => {
      state.isDemDXTemplate = action?.payload || null;
    },
    setIsSummaryStreamingData: (state, action) => {
      state.isSummaryStreaming = action?.payload || false;
    },
    setShowPatientReferralLetterModal: (state, action) => {
      state.showPatientReferralLetterModal = action?.payload || false;
    },
    setShowPatientPrescriptionModal: (state, action) => {
      state.showPatientPrescriptionModal = action?.payload || false;
    },
    setPatientPrescriptionData: (state, action) => {
      state.patientPrescription = action?.payload || false;
    },
    setShowEditAiTemplateModal: (state, action) => {
      if (typeof action.payload === "object" && action.payload !== null) {
        state.showEditAiTemplateModal = action.payload.show ?? false;
        state.templateForEditModal = action.payload.template ?? null;
        state.selectedTemplateName = action.payload.selectedTemplateName ?? "";
      } else {
        state.showEditAiTemplateModal = action.payload || false;
        state.templateForEditModal = null;
        state.selectedTemplateName = "";
      }
    },
    setIsDemDXGlobalCheckData: (state, action) => {
      state.isDemDXGlobalCheck = action?.payload || false;
    },
    setDemDxSummaryData: (state, action) => {
      state.demDxSummary = action?.payload || "";
    },
    setIsDemDxActiveData: (state, action) => {
      state.isDemDxActive = action?.payload || false;
    },
    setDemDXForChatData: (state, action) => {
      state.demDXForChat = action?.payload || false;
    },
    setDemDXPatientData: (state, action) => {
      state.demDXPatient = action?.payload || false;
    },
    setIsCallStartedData: (state, action) => {
      state.isCallStarted = action?.payload || false;
    },
    openVitalsModal: (state, action) => {
      state.showAddVitalsModal = true;
      state.isEditMode = action.payload?.isEdit || false;
      state.vitalToEdit = action.payload?.vital || null;
      state.vitalType = action.payload?.vitalType || null;
      state.vitalMessageId = action.payload?.vitalMessageId || null;
    },
    closeVitalsModal: (state) => {
      state.showAddVitalsModal = false;
      state.isEditMode = false;
      state.vitalToEdit = null;
      state.vitalType = null;
      state.vitalMessageId = null;
    },
    setOpenDeleteVitalsModal: (state, action) => {
      state.showDeleteVitalsModal = action.payload?.show || false;
      state.vitalType = action.payload?.vitalType || null;
      state.vitalToDelete = action.payload?.vital || null;
    },
    setIsPatientDetailsLoadingData: (state, action) => {
      state.isPatientDetailsLoading = action?.payload || false;
    },
    setPatientAllergyToEditData: (state, action) => {
      if (action?.payload === null) {
        state.isAllergiesEditMode = false;
        state.selectedPatientAllergy = null;
      } else {
        state.isAllergiesEditMode = true;
        state.selectedPatientAllergy = action?.payload || {};
      }
    },
    setPatientAllergyToDeleteData: (state, action) => {
      if (action?.payload === null) {
        state.selectedPatientAllergy = null;
        state.showDeleteAllergiesModal = false;
      } else {
        state.selectedPatientAllergy = action?.payload || {};
        state.showDeleteAllergiesModal = true;
      }
    },
    setPatientConditionRelatedToEditData: (state, action) => {
      if (action?.payload === null) {
        state.isConditionRelatedEditMode = false;
        state.selectedPatientConditionRelated = null;
      } else {
        state.isConditionRelatedEditMode = true;
        state.selectedPatientConditionRelated = action?.payload || {};
      }
    },
    setPatientConditionRelatedToDeleteData: (state, action) => {
      if (action?.payload === null) {
        state.selectedPatientConditionRelated = null;
        state.showDeleteConditionRelatedModal = false;
      } else {
        state.selectedPatientConditionRelated = action?.payload || {};
        state.showDeleteConditionRelatedModal = true;
      }
    },
    setPatientMedicationsToEditData: (state, action) => {
      if (action?.payload === null) {
        state.isMedicationsEditMode = false;
        state.selectedPatientMedications = null;
      } else {
        state.isMedicationsEditMode = true;
        state.selectedPatientMedications = action?.payload || {};
      }
    },
    setPatientMedicationsToDeleteData: (state, action) => {
      if (action?.payload === null) {
        state.selectedPatientMedications = null;
        state.showDeleteMedicationsModal = false;
      } else {
        state.selectedPatientMedications = action?.payload || {};
        state.showDeleteMedicationsModal = true;
      }
    },
    setIsFinalSummaryData: (state, action) => {
      state.isFinalSummary = action.payload ?? true;
    },
    setPatientNotesData: (state, action) => {
      state.PatientNotes = action.payload;
    },
    setPatientConsultationMediaButtonModeData: (state, action) => {
      state.consultationMediaButtonMode = action.payload;
    },
    setIsNotesExpandedData: (state, action) => {
      state.isNotesExpanded = action.payload;
    },
    setTranscriptData: (state, action) => {
      state.transcript = action.payload || "";
    },
    setShowAddPatientModalData: (state, action) => {
      state.showAddPatientModal = action?.payload || false;
    },
    setShowPlayPauseBtnData: (state, action) => {
      state.showPlayPauseBtn = action.payload || false;
    },
    setOpenSignatureDialogData: (state, action) => {
      state.signatureDialog = {
        ...state.signatureDialog,
        ...action.payload,
      };
    },
    setSignatureDetailsData: (state, action) => {
      state.signatureDetails = action.payload;
    },
    setConsultationPausedData: (state, action) => {
      state.consultationPaused = action.payload || false;
    },
    setConsultationStopAfterRefreshData: (state, action) => {
      state.consultationStopAfterRefresh = action.payload || false;
    },
    setFreeTypeModeData: (state, action) => {
      state.freeTypeMode = action.payload || false;
    },
    setIsLocallyCompletedData: (state, action) => {
      state.isLocallyCompleted = action.payload || false;
    },
    setPreConsultationTemplateData: (state, action) => {
      state.preConsultationTemplate = action.payload || null;
    },
    addAllergyOptimisticData: (state, action) => {
      state.patientAllergies = [
        ...(state.patientAllergies || []),
        action.payload,
      ];
    },
    removeAllergyByIdData: (state, action) => {
      state.patientAllergies = state.patientAllergies?.filter(
        (a) => a.id !== action.payload,
      );
    },
    setIsPatientListLoaderData: (state, action) => {
      state.setIsPatientListLoader = action.payload || false;
    },
    setVitalsDetailsData: (state, action) => {
      state.vitalsDetails = action.payload || null;
      if (action.payload?.vitalMessageId) {
        state.vitalMessageId = action.payload.vitalMessageId;
      }
    },
    setVaccineDetailsData: (state, action) => {
      state.vaccineDetails = action.payload || null;
    },
    setOpenVaccineDialogData: (state, action) => {
      state.openVaccineDialog = action.payload || false;
    },
    setBookingDetailsData: (state, action) => {
      state.bookingDetails = action.payload || null;
      if (action.payload?.appointmentMessageId) {
        state.appointmentMessageId = action.payload.appointmentMessageId;
      }
    },
    setOpenBookingDialogData: (state, action) => {
      state.openBookingDialog =
        action.payload?.open !== undefined
          ? action.payload.open
          : action.payload || false;
      state.appointmentMessageId = action.payload?.appointmentMessageId || null;
    },
    setOpenRefDialogData: (state, action) => {
      state.openRefDialog = action.payload || false;
    },
    setLetterDetailsData: (state, action) => {
      state.letterDetails = action.payload || null;
    },
    setPreConsultationTranscriptionData: (state, action) => {
      state.preConsultationTranscription = action?.payload || null;
    },
    setPreConsultAddtoSummaryData: (state, action) => {
      state.preConsultAddtoSummary =
        typeof action.payload === "boolean"
          ? action.payload
          : state.preConsultAddtoSummary;
    },
    setSearchedDoctorsData: (state, action) => {
      state.searchedDoctor = action?.payload || "";
    },
    setHasPreConsultData: (state, action) => {
      state.hasPreConsult = action?.payload || false;
    },
    setisHandleStartConsultationData: (state, action) => {
      state.isHandleStartConsultation = action?.payload || false;
    },
    setConsultationAuditTimelineData: (state, action) => {
      state.consultationAuditTimeline = action?.payload || [];
    },
    setOpenPrescriptionDialogData: (state, action) => {
      state.openPrescriptionDialog = action?.payload || false;
    },
    setPrescriptionDetailsData: (state, action) => {
      state.prescriptionDetails = action?.payload || null;
    },
    setDynamicPrescriptionsData: (state, action) => {
      state.dynamicPrescriptions = action?.payload || [
        {
          id: Date.now(),
          value: "",
          quantity: "",
          dose: "",
          notes: "",
          prescribedItemId: "",
        },
      ];
    },
    setPrescriptionIdData: (state, action) => {
      state.prescriptionId = action?.payload || "";
    },
    setIsPrescriptionUpdateData: (state, action) => {
      state.isPrescriptionUpdate = action?.payload || false;
    },
    setSelectedPrescriptionCategoryData: (state, action) => {
      state.selectedPrescriptionCategory = action?.payload || "private";
    },
    setQuickActionsTabSwitchData: (state, action) => {
      state.quickActionsTabSwitch = action?.payload || 0;
    },
    setSelectedCompanyTagsData: (state, action) => {
      state.selectedCompanyTags = action?.payload || [];
    },
    setSelectedConsultationData: (state, action) => {
      state.selectedConsultation = action?.payload || null;
    },
    setPatientSummaryForActionsData: (state, action) => {
      state.patientSummaryForActions = action?.payload || null;
    },
    setFilteredPatientsData: (state, action) => {
      state.filteredPatients = action?.payload || null;
    },
    setComingFromPatientListViewData: (state, action) => {
      state.comingFromPatientListView = action.payload || false;
    },
    setPaymentAuditData: (state, action) => {
      state.paymentAuditData = action?.payload || null;
    },
    setPreConsultData: (state, action) => {
      state.preConsultData = action?.payload || null;
    },
    setPatientConsentSignatureData: (state, action) => {
      state.patientConsentSignature = action?.payload || null;
    },
    setNhs111FormData: (state, action) => {
      state.nhs111FormData = action?.payload || null;
    },
    setNhs111PrescriptionsData: (state, action) => {
      state.nhs111Prescriptions = action?.payload || null;
    },
    setNhs111EmergencySupplyMedicationsData: (state, action) => {
      state.nhs111EmergencySupplyMedications = action?.payload || null;
    },
    setConsultationServiceCodeData: (state, action) => {
      state.consultationServiceCode = action?.payload || null;
    },
    setShowMultipleVaccineCertificatePreviewData: (state, action) => {
      state.showMultipleVaccineCertificatePreview = action?.payload || false;
    },
    setMultipleVaccinationImageData: (state, action) => {
      state.multipleVaccinationImage = action?.payload || null;
    },
    setViewOpenData: (state, action) => {
      state.viewOpen = action?.payload || false;
    },
    setisManualSubmitedData: (state, action) => {
      state.isManualSubmited = action.payload || false;
    },
    incrementImageUploadCompleted: (state, action) => {
      state.isImageDocUploaded = action.payload;
    },
    setImageDocsDetailsData: (state, action) => {
      state.imageDocDetails = action.payload || null;
    },
    incrementTreatmentPlanCompleted: (state, action) => {
      state.isTreatmenPlanCreated = action.payload;
    },
    setTreatmentPlanDetailssData: (state, action) => {
      state.treatmentPlanDetails = action.payload || null;
    },
    setGeneratedVaccinationCertificateData: (state, action) => {
      state.generatedVaccinationCertificate = action.payload || null;
    },
    setTravelDestinationsData: (state, action) => {
      if (action.payload) {
        state.travelDestinations = action.payload;
      }
    },
    setConsultationsState: (state, action) => {
      state.patientConsultations = action.payload || null;
      state.showPatientConsultationsLoader = false;
      state.selectedConsultation = null;
      state.consultationPoints = null;
      state.isConsultationPointsLoading = false;
    },
    setSnomedCodesData: (state, action) => {
      state.snomedCodes = action.payload || [];
    },

    clearConsultationsState: (state) => {
      state.patientConsultations = null;
      state.showPatientConsultationsLoader = false;
      state.selectedConsultation = null;
      state.consultationPoints = null;
      state.isConsultationPointsLoading = false;
      state.patientSummaryForActions = null;
    },

    resetSelectedConsultation: (state) => {
      state.selectedConsultation = null;
      state.consultationPoints = null;
      state.patientSummaryForActions = null;
    },
    updateTreatmentPlanAIChatMessage: (state, action) => {
      const newMessage = action.payload;
      const newPlanId = newMessage?.details?.treatmentPlanId;

      if (!newPlanId) {
        state.patientAIChatMessages.push(newMessage);
        return;
      }

      const getPlanId = (msg) => {
        try {
          const details = msg.details;
          if (!details) return null;
          // Shape 1: details is plain treatmentPlan object
          if (details.treatmentPlanId) return details.treatmentPlanId;
          // Shape 2: details has a payload string
          if (details.payload) {
            const parsed = JSON.parse(details.payload);
            return (
              parsed?.treatmentPlan?.treatmentPlanId ??
              parsed?.treatmentPlanId ??
              null
            );
          }
          return null;
        } catch {
          return null;
        }
      };

      const existingIndex = state.patientAIChatMessages.findIndex(
        (msg) => msg.actionId === 15 && getPlanId(msg) === newPlanId,
      );

      if (existingIndex !== -1) {
        state.patientAIChatMessages[existingIndex] = newMessage;
      } else {
        // No match found — remove any stale duplicates then push
        state.patientAIChatMessages = state.patientAIChatMessages.filter(
          (msg) => !(msg.actionId === 15 && getPlanId(msg) === newPlanId),
        );
        state.patientAIChatMessages.push(newMessage);
      }
    },
    removeTreatmentPlanAIChatMessage: (state, action) => {
      const planId = action.payload; // treatmentPlanId string
      const getPlanId = (msg) => {
        try {
          const d = msg.details;
          if (!d) return null;
          if (d.treatmentPlanId) return d.treatmentPlanId;
          if (d.payload) {
            const p = JSON.parse(d.payload);
            return (
              p?.treatmentPlanId || p?.treatmentPlan?.treatmentPlanId || null
            );
          }
        } catch {
          return null;
        }
        return null;
      };
      state.patientAIChatMessages = state.patientAIChatMessages.filter(
        (msg) => !(msg.actionId === 15 && getPlanId(msg) === planId),
      );
    },
    setNhsContraceptionFormData: (state, action) => {
      state.nhsContraceptionFormData = action.payload || null;
    },
    setNhsSinusitisFormData: (state, action) => {
      state.nhsSinusitisFormData = action.payload || null;
    },
    setNhsUtiFormData: (state, action) => {
      state.nhsUtiFormData = action.payload || null;
    },
    setNhsSoreThroatFormData: (state, action) => {
      state.nhsSoreThroatFormData = action.payload || null;
    },
    setNhsImpetigoFormData: (state, action) => {
      state.nhsImpetigoFormData = action.payload || null;
    },
    setNhsInsectBitesFormData: (state, action) => {
      state.nhsInsectBitesFormData = action.payload || null;
    },
    setNhsShinglesFormData: (state, action) => {
      state.nhsShinglesFormData = action.payload || null;
    },
    setNhsAomFormData: (state, action) => {
      state.nhsAomFormData = action.payload || null;
    },
    setNhsAhtFormData: (state, action) => {
      state.nhsAhtFormData = action.payload || null;
    },
    setShowPathwayCompletionModalData: (state, action) => {
      state.showPathwayCompletionModal = action.payload ?? false;
    },
    setPendingCalculatorIdData: (state, action) => {
      state.pendingCalculatorId = action.payload ?? null;
    },
    setHypertensionInitialFormData: (state, action) => {
      state.hypertensionInitialFormData = action.payload || null;
    },
    setHypertensionABPMFittingFormData: (state, action) => {
      state.hypertensionABPMFittingFormData = action.payload || null;
    },
    setSurgeryData: (state, action) => {
      state.surgeryData = action.payload || null;
    },
    setisConsultationDataLoadingData: (state, action) => {
      state.isConsultationDataLoading = action?.payload || false;
    },
    setAccessRecordData: (state, action) => {
      state.accessRecordData = action.payload || null;
    },
    setHypertensionABPMFollowupFormData: (state, action) => {
      state.hypertensionABPMFollowupFormData = action.payload || null;
    },
    setCompletedTasksForConsultationData: (state, action) => {
      // payload: { consultationId, labels: string[] }
      const { consultationId, labels } = action.payload || {};
      if (consultationId) {
        state.completedTasksByConsultation[consultationId] = labels || [];
      }
    },
    toggleCompletedTaskForConsultationData: (state, action) => {
      // payload: { consultationId, label: string }
      const { consultationId, label } = action.payload || {};
      if (!consultationId || !label) return;
      const current = state.completedTasksByConsultation[consultationId] || [];
      const idx = current.indexOf(label);
      if (idx === -1) {
        state.completedTasksByConsultation[consultationId] = [
          ...current,
          label,
        ];
      } else {
        state.completedTasksByConsultation[consultationId] = current.filter(
          (l) => l !== label,
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientListData.pending, (state) => {
        state.patientListLoader = true;
      })
      .addCase(getPatientListData.fulfilled, (state, action) => {
        state.mappedPatients = action?.payload || [];
        state.patientListLoader = false;
      })
      .addCase(getPatientListData.rejected, (state, action) => {
        state.patientListLoader = false;
      })
      .addCase(addNewPatientData.pending, (state) => {
        state.addPatientLoader = true;
      })
      .addCase(addNewPatientData.fulfilled, (state, action) => {
        state.addPatientLoader = false;
        state.selectedPatientDetails = action?.payload;
        const appResponse = action?.payload;
        if (appResponse) {
          state.selectedPatient = appResponse?.patientName;
        }
      })
      .addCase(addNewPatientData.rejected, (state, action) => {
        state.addPatientLoader = false;
      })
      .addCase(addNewPatientMatchData.pending, (state) => {
        state.addPatientLoader = true;
      })
      .addCase(addNewPatientMatchData.fulfilled, (state, action) => {
        state.addPatientLoader = false;
        state.selectedPatientDetails = action?.payload;
        const appResponse = action?.payload;
        if (appResponse) {
          state.selectedPatient = appResponse?.patientName;
        }
      })
      .addCase(addNewPatientMatchData.rejected, (state, action) => {
        state.addPatientLoader = false;
      })
      .addCase(getPatientAppointmentsByIdData.pending, (state) => {
        state.patientAppointmentListLoader = true;
      })
      .addCase(getPatientAppointmentsByIdData.fulfilled, (state, action) => {
        state.patientAppointmentList = action?.payload || [];
        state.patientAppointmentListLoader = false;
      })
      .addCase(getPatientAppointmentsByIdData.rejected, (state, action) => {
        state.patientAppointmentListLoader = false;
      })
      .addCase(getPaymentAnalyticsByPatientIdData.pending, (state) => {
        state.paymentAnalyticsLoader = true;
      })
      .addCase(
        getPaymentAnalyticsByPatientIdData.fulfilled,
        (state, action) => {
          state.paymentAnalytics = action?.payload || [];
          state.paymentAnalyticsLoader = false;
        },
      )
      .addCase(getPaymentAnalyticsByPatientIdData.rejected, (state, action) => {
        state.paymentAnalyticsLoader = false;
      })
      .addCase(generateAiTemplateData.pending, (state) => {
        state.aiTemplateLoader = true;
      })
      .addCase(generateAiTemplateData.fulfilled, (state, action) => {
        state.aiTemplate = action?.payload || [];
        state.aiTemplateLoader = false;
      })
      .addCase(generateAiTemplateData.rejected, (state, action) => {
        state.aiTemplateLoader = false;
      })
      .addCase(saveAiTemplateData.pending, (state, action) => {
        state.aiTemplateLoader = true;
      })
      .addCase(saveAiTemplateData.fulfilled, (state, action) => {
        state.aiTemplateLoader = false;
      })
      .addCase(saveAiTemplateData.rejected, (state, action) => {
        state.aiTemplateLoader = false;
      })
      .addCase(generatePatientSummaryData.pending, (state) => {
        state.patientSummaryLoader = true;
      })
      .addCase(generatePatientSummaryData.fulfilled, (state, action) => {
        state.patientSummary = action?.payload || [];
        state.patientSummaryLoader = false;
      })
      .addCase(generatePatientSummaryData.rejected, (state, action) => {
        state.patientSummaryLoader = false;
      })
      .addCase(addPatientVitalsData.pending, (state) => {
        state.addPatientVitalsLoader = true;
      })
      .addCase(addPatientVitalsData.fulfilled, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(addPatientVitalsData.rejected, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(getPatientVitalsData.pending, (state) => {
        state.patientVitalsLoading = true;
      })
      .addCase(getPatientVitalsData.fulfilled, (state, action) => {
        state.patientVitalsLoading = false;
        state.patientVitals = action?.payload;
      })
      .addCase(getPatientVitalsData.rejected, (state, action) => {
        state.patientVitalsLoading = false;
      })
      .addCase(generateReferalLetterData.pending, (state) => {
        state.referralLetterLoader = true;
      })
      .addCase(generateReferalLetterData.fulfilled, (state, action) => {
        state.referralLetter = action?.payload || "";
        state.referralLetterLoader = false;
      })
      .addCase(generateReferalLetterData.rejected, (state, action) => {
        state.referralLetterLoader = false;
      })
      .addCase(addPatientAllergiesData.pending, (state) => {
        state.addPatientAllergiesLoader = true;
      })
      .addCase(addPatientAllergiesData.fulfilled, (state, action) => {
        state.addPatientAllergiesLoader = false;
      })
      .addCase(addPatientAllergiesData.rejected, (state, action) => {
        state.addPatientAllergiesLoader = false;
      })
      .addCase(getPatientAllergiesData.pending, (state) => {
        state.patientAllergies = [];
        state.patientAllergiesLoading = true;
      })
      .addCase(getPatientAllergiesData.fulfilled, (state, action) => {
        state.patientAllergiesLoading = false;
        state.patientAllergies = action?.payload;
      })
      .addCase(getPatientAllergiesData.rejected, (state, action) => {
        state.patientAllergies = [];
        state.patientAllergiesLoading = false;
      })
      .addCase(addPatientCondtionRelatedData.pending, (state) => {
        state.addPatientConditionRelatedLoader = true;
      })
      .addCase(addPatientCondtionRelatedData.fulfilled, (state, action) => {
        state.addPatientConditionRelatedLoader = false;
      })
      .addCase(addPatientCondtionRelatedData.rejected, (state, action) => {
        state.addPatientConditionRelatedLoader = false;
      })
      .addCase(getPatientConditionRelatedData.pending, (state) => {
        state.patientConditionRelated = [];
        state.patientCondtionRelatedLoading = true;
      })
      .addCase(getPatientConditionRelatedData.fulfilled, (state, action) => {
        state.patientCondtionRelatedLoading = false;
        state.patientConditionRelated = action?.payload;
      })
      .addCase(getPatientConditionRelatedData.rejected, (state, action) => {
        state.patientConditionRelated = [];
        state.patientCondtionRelatedLoading = false;
      })
      .addCase(addPatientMedicationsData.pending, (state) => {
        state.addPatientMedicationsLoader = true;
      })
      .addCase(addPatientMedicationsData.fulfilled, (state, action) => {
        state.addPatientMedicationsLoader = false;
      })
      .addCase(addPatientMedicationsData.rejected, (state, action) => {
        state.addPatientMedicationsLoader = false;
      })
      .addCase(addPatientConsultationData.pending, (state) => {
        state.addPatientConsultationLoader = true;
      })
      .addCase(addPatientConsultationData.fulfilled, (state, action) => {
        state.addPatientConsultation = action.payload;
        state.addPatientConsultationLoader = false;
      })
      .addCase(addPatientConsultationData.rejected, (state, action) => {
        state.addPatientConsultationLoader = false;
      })
      .addCase(getPatientMedicationsData.pending, (state) => {
        state.patientMedications = [];
        state.patientMedicationsLoading = true;
      })
      .addCase(getPatientMedicationsData.fulfilled, (state, action) => {
        state.patientMedicationsLoading = false;
        state.patientMedications = action?.payload;
      })
      .addCase(getPatientMedicationsData.rejected, (state, action) => {
        state.patientMedications = [];
        state.patientMedicationsLoading = false;
      })
      .addCase(addupdateConsultationSummaryData.pending, (state) => {
        state.addConsultationSummaryLoader = true;
      })
      .addCase(addupdateConsultationSummaryData.fulfilled, (state, action) => {
        state.addConsultationSummaryLoader = false;
      })
      .addCase(addupdateConsultationSummaryData.rejected, (state, action) => {
        state.addConsultationSummaryLoader = false;
      })
      .addCase(updateConsultationTemplateData.pending, (state) => {
        state.updateConsultationSummaryLoader = true;
      })
      .addCase(updateConsultationTemplateData.fulfilled, (state, action) => {
        state.updateConsultationSummaryLoader = false;
      })
      .addCase(updateConsultationTemplateData.rejected, (state, action) => {
        state.updateConsultationSummaryLoader = false;
      })
      .addCase(getAppointmentsByPharmacyIdData.pending, (state, action) => {
        state.usersAvailabilityLoader = true;
      })
      .addCase(getAppointmentsByPharmacyIdData.fulfilled, (state, action) => {
        state.usersAvailabilityLoader = false;
        state.usersAvailability = action?.payload;
      })
      .addCase(getAppointmentsByPharmacyIdData.rejected, (state, action) => {
        state.usersAvailabilityLoader = false;
      })
      .addCase(updateConsultationActionsData.pending, (state, action) => {
        state.updateConsultationActionsLoader = true;
      })
      .addCase(updateConsultationActionsData.fulfilled, (state, action) => {
        state.updateConsultationActionsLoader = false;
      })
      .addCase(updateConsultationActionsData.rejected, (state, action) => {
        state.updateConsultationActionsLoader = false;
      })
      .addCase(deleteConsultationActionData.pending, (state) => {
        state.deleteConsultationActionLoader = true;
      })
      .addCase(deleteConsultationActionData.fulfilled, (state, action) => {
        state.deleteConsultationActionLoader = false;

        const { vaccineName } = action.meta.arg || {};
        const targetName = String(vaccineName || "")
          .trim()
          .toLowerCase();

        const removeFromDraftPayload = (payload, target) => {
          try {
            const parsed =
              typeof payload === "string" ? JSON.parse(payload) : payload;
            if (!parsed || typeof parsed !== "object") return null;
            if (!target) return payload;

            const vaccineItems = Array.isArray(parsed.vaccineItems)
              ? parsed.vaccineItems
              : Array.isArray(parsed.vaccinations)
              ? parsed.vaccinations
              : Array.isArray(parsed.items)
              ? parsed.items
              : [];

            const calculatorResults = Array.isArray(parsed.calculatorResults)
              ? parsed.calculatorResults
              : [];

            const filteredVaccineItems = vaccineItems.filter(
              (item) =>
                String(item?.vaccineName || item?.medication || "")
                  .trim()
                  .toLowerCase() !== target,
            );

            const filteredCalculatorResults = calculatorResults.filter(
              (item) =>
                String(item?.medication || item?.vaccineName || "")
                  .trim()
                  .toLowerCase() !== target,
            );

            const next = { ...parsed };
            if (Array.isArray(parsed.vaccineItems))
              next.vaccineItems = filteredVaccineItems;
            if (Array.isArray(parsed.vaccinations))
              next.vaccinations = filteredVaccineItems;
            if (Array.isArray(parsed.items)) next.items = filteredVaccineItems;
            if (Array.isArray(parsed.calculatorResults))
              next.calculatorResults = filteredCalculatorResults;

            const remainingCount =
              (next.vaccineItems?.length || 0) +
              (next.vaccinations?.length || 0) +
              (next.items?.length || 0);

            if (remainingCount === 0) return null;
            return typeof payload === "string" ? JSON.stringify(next) : next;
          } catch (e) {
            return null;
          }
        };

        // Update chat drafts in state (remove only the selected vaccine)
        state.patientAIChatMessages = state.patientAIChatMessages
          .map((msg) => {
            if (!msg || msg.actionId !== 12) return msg;
            const detailsPayload = msg?.details?.payload;
            if (!detailsPayload) return msg;
            const updatedPayload = removeFromDraftPayload(
              detailsPayload,
              targetName,
            );
            if (!updatedPayload) return null;
            return {
              ...msg,
              details: { ...msg.details, payload: updatedPayload },
            };
          })
          .filter(Boolean);

        // Also update consultationData.actions draft payload to keep UI in sync
        if (state.consultationData?.actions?.length) {
          state.consultationData.actions = state.consultationData.actions
            .map((actionItem) => {
              if (
                actionItem?.actionName !== "CreateVaccineDraft" &&
                String(actionItem?.actionNumber) !== "12"
              ) {
                return actionItem;
              }
              const updatedPayload = removeFromDraftPayload(
                actionItem?.payload,
                targetName,
              );
              if (!updatedPayload) return null;
              return { ...actionItem, payload: updatedPayload };
            })
            .filter(Boolean);
        }
        if (targetName) {
          state.patientAIChatMessages = state.patientAIChatMessages.filter(
            (msg) => {
              if (!msg || msg.actionId !== 12) return true;

              const detailsPayload = msg?.details?.payload;
              if (!detailsPayload) return true;

              try {
                const parsed =
                  typeof detailsPayload === "string"
                    ? JSON.parse(detailsPayload)
                    : detailsPayload;
                const items = Array.isArray(parsed?.vaccineItems)
                  ? parsed.vaccineItems
                  : [];
                if (items.length === 0) return true;
                const hasMatch = items.some(
                  (item) =>
                    String(item?.vaccineName || "")
                      .trim()
                      .toLowerCase() === targetName,
                );
                return !hasMatch;
              } catch (e) {
                return true;
              }
            },
          );
        }
      })
      .addCase(deleteConsultationActionData.rejected, (state) => {
        state.deleteConsultationActionLoader = false;
      })
      .addCase(deletePrescriptionDraftData.pending, (state) => {
        state.deletePrescriptionDraftLoader = true;
      })
      .addCase(deletePrescriptionDraftData.fulfilled, (state, action) => {
        state.deletePrescriptionDraftLoader = false;
        const { actionNumber } = action.meta.arg;
        state.patientAIChatMessages = state.patientAIChatMessages.filter(
          (msg) => String(msg.actionId) !== String(actionNumber),
        );
      })
      .addCase(deletePrescriptionDraftData.rejected, (state) => {
        state.deletePrescriptionDraftLoader = false;
      })

      .addCase(updateConsultationStatusData.pending, (state, action) => {
        state.updateConsultationStatusLoader = true;
      })
      .addCase(updateConsultationStatusData.fulfilled, (state, action) => {
        state.updateConsultationStatusLoader = false;
      })
      .addCase(updateConsultationStatusData.rejected, (state, action) => {
        state.updateConsultationStatusLoader = false;
      })
      .addCase(addConsultationTemplateData.pending, (state, action) => {
        state.addConsultationTemplateLoader = true;
      })
      .addCase(addConsultationTemplateData.fulfilled, (state, action) => {
        state.addConsultationTemplateLoader = false;
      })
      .addCase(addConsultationTemplateData.rejected, (state, action) => {
        state.addConsultationTemplateLoader = false;
      })
      .addCase(savePatientAppointmentData.pending, (state, action) => {})
      .addCase(savePatientAppointmentData.fulfilled, (state, action) => {})
      .addCase(savePatientAppointmentData.rejected, (state, action) => {})
      .addCase(getPatientByKeywordData.pending, (state, action) => {
        state.filteredPatientsLoader = true;
      })
      .addCase(getPatientByKeywordData.fulfilled, (state, action) => {
        state.filteredPatientsLoader = false;
        state.filteredPatients = action?.payload;
      })
      .addCase(getPatientByKeywordData.rejected, (state, action) => {
        state.filteredPatients = false;
      })
      .addCase(getPatientConsultationsData.pending, (state, action) => {
        state.showPatientConsultationsLoader = true;
        state.patientConsultations = null; // ✅ Clear previous data
        state.consultationPoints = null; // ✅ Clear summary data
      })
      .addCase(getPatientConsultationsData.fulfilled, (state, action) => {
        state.showPatientConsultationsLoader = false;
        state.patientConsultations = action?.payload;

        // Only process if we have data
        const appResponse = action?.payload;
        if (appResponse && Array.isArray(appResponse)) {
          state.patientPrescriptionConsultation =
            appResponse?.flatMap((consultation) =>
              (consultation?.actions || [])
                ?.filter((action) => action?.actionNumber === "1")
                ?.map((action) => ({
                  action,
                  createdOn: consultation.createdOn,
                  consultationId: consultation.consultationId,
                })),
            ) || [];
        } else {
          state.patientPrescriptionConsultation = [];
        }
      })
      .addCase(getPatientConsultationsData.rejected, (state, action) => {
        state.showPatientConsultationsLoader = false;
        state.patientConsultations = null; // ✅ Clear on error
        state.patientPrescriptionConsultation = [];
      })
      .addCase(getCompanyData.pending, (state) => {
        state.isCompanyLoading = true;
      })
      .addCase(getCompanyData.fulfilled, (state, action) => {
        state.isCompanyLoading = false;
        state.companyData = action?.payload;
      })
      .addCase(getCompanyData.rejected, (state, action) => {
        state.isCompanyLoading = false;
        state.companyData = [];
      })
      .addCase(generateDemDXAssessmentsData.pending, (state) => {
        state.isDemDXTemplatesLoading = true;
      })
      .addCase(generateDemDXAssessmentsData.fulfilled, (state, action) => {
        state.demDXTemplates = action?.payload;
        state.isDemDXTemplatesLoading = false;
      })
      .addCase(generateDemDXAssessmentsData.rejected, (state, action) => {
        state.demDXTemplates = [];
        state.isDemDXTemplatesLoading = false;
      })
      .addCase(getPatientByPatientIdData.pending, (state, action) => {
        state.filteredPatientsLoader = true;
        state.isPatientDetailsLoading = true;
      })
      .addCase(getPatientByPatientIdData.fulfilled, (state, action) => {
        state.filteredPatientsLoader = false;
        state.isPatientDetailsLoading = false;
        state.selectedPatientDetails = action?.payload;
        const appResponse = action?.payload;

        if (appResponse) {
          state.selectedPatient = [appResponse?.title, appResponse?.patientName]
            .filter(Boolean)
            .join(" ");
        }
      })
      .addCase(getPatientByPatientIdData.rejected, (state, action) => {
        state.filteredPatients = false;
        state.isPatientDetailsLoading = false;
        state.selectedPatientDetails = null;
      })
      .addCase(importPatientFromTitanData.pending, (state) => {
        state.importPatientFromTitanLoader = true;
      })
      .addCase(importPatientFromTitanData.fulfilled, (state, action) => {
        state.importPatientFromTitanLoader = false;
        state.importedPatientFromTitan = action?.payload;
      })
      .addCase(importPatientFromTitanData.rejected, (state, action) => {
        state.importPatientFromTitanLoader = false;
      })
      .addCase(SaveDemDxLogsAndSummaryData.pending, (state) => {
        state.isDemDXTemplatesLoading = true;
      })
      .addCase(SaveDemDxLogsAndSummaryData.fulfilled, (state, action) => {
        state.isDemDXTemplatesLoading = false;
      })
      .addCase(SaveDemDxLogsAndSummaryData.rejected, (state, action) => {
        state.isDemDXTemplatesLoading = false;
      })

      .addCase(saveAIChatMessageData.pending, (state) => {
        state.saveAIChatMessageDataLoader = true;
      })
      .addCase(saveAIChatMessageData.fulfilled, (state, action) => {
        state.saveAIChatMessageDataLoader = false;
        state.isAIChatMessageSaved = action?.payload;
      })
      .addCase(saveAIChatMessageData.rejected, (state, action) => {
        state.saveAIChatMessageDataLoader = false;
      })
      .addCase(GetPatientVitalsSummaryByPatientIdData.pending, (state) => {
        state.patientVitalsLoading = true;
        state.patientVitalsSummary = [];
      })
      .addCase(
        GetPatientVitalsSummaryByPatientIdData.fulfilled,
        (state, action) => {
          state.patientVitalsLoading = false;
          state.patientVitalsSummary = action?.payload;
        },
      )
      .addCase(
        GetPatientVitalsSummaryByPatientIdData.rejected,
        (state, action) => {
          state.patientVitalsLoading = false;
          state.patientVitalsSummary = [];
        },
      )
      .addCase(updatePatientDetailsData.pending, (state) => {
        state.updatePatientDetailsLoader = true;
      })
      .addCase(updatePatientDetailsData.fulfilled, (state) => {
        state.updatePatientDetailsLoader = false;
      })
      .addCase(updatePatientDetailsData.rejected, (state) => {
        state.updatePatientDetailsLoader = false;
      })
      .addCase(addPatientConsultationNotesData.pending, (state) => {})
      .addCase(addPatientConsultationNotesData.fulfilled, (state, action) => {})
      .addCase(addPatientConsultationNotesData.rejected, (state) => {})
      .addCase(updatePatientVitalsData.pending, (state) => {
        state.addPatientVitalsLoader = true;
      })
      .addCase(updatePatientVitalsData.fulfilled, (state) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(updatePatientVitalsData.rejected, (state) => {
        state.deletePatientVitalsLoader = false;
      })
      .addCase(addConsultationFeedbackData.pending, (state) => {
        state.consultationFeedbackLoader = true;
      })
      .addCase(addConsultationFeedbackData.fulfilled, (state) => {
        state.consultationFeedbackLoader = false;
      })
      .addCase(addConsultationFeedbackData.rejected, (state) => {
        state.consultationFeedbackLoader = false;
        state.addPatientVitalsLoader = false;
      })
      .addCase(addUpdatedTranscriptionData.pending, (state) => {
        state.consultationTranscriptionLoader = true;
      })
      .addCase(addUpdatedTranscriptionData.fulfilled, (state) => {
        state.consultationTranscriptionLoader = false;
      })
      .addCase(addUpdatedTranscriptionData.rejected, (state) => {
        state.consultationTranscriptionLoader = false;
      })
      .addCase(deletePatientAllergiesData.pending, (state) => {
        state.deletePatientAllergiesLoader = true;
      })
      .addCase(deletePatientAllergiesData.fulfilled, (state) => {
        state.deletePatientAllergiesLoader = false;
      })
      .addCase(deletePatientAllergiesData.rejected, (state) => {
        state.deletePatientAllergiesLoader = false;
      })
      .addCase(deletePatientConditionRelatedData.pending, (state) => {
        state.deletePatientConditionRelatedLoader = true;
      })
      .addCase(deletePatientConditionRelatedData.fulfilled, (state) => {
        state.deletePatientConditionRelatedLoader = false;
      })
      .addCase(deletePatientConditionRelatedData.rejected, (state) => {
        state.deletePatientConditionRelatedLoader = false;
      })
      .addCase(deletePatientMedicationsData.pending, (state) => {
        state.deletePatientMedicationsLoader = true;
      })
      .addCase(deletePatientMedicationsData.fulfilled, (state) => {
        state.deletePatientMedicationsLoader = false;
      })
      .addCase(deletePatientMedicationsData.rejected, (state) => {
        state.deletePatientMedicationsLoader = false;
      })
      .addCase(addPatientConsentData.pending, (state) => {})
      .addCase(addPatientConsentData.fulfilled, (state, action) => {})
      .addCase(addPatientConsentData.rejected, (state) => {})

      .addCase(addDeepGramTranscriptionData.pending, (state) => {
        state.deepGramTranscription = true;
      })
      .addCase(addDeepGramTranscriptionData.fulfilled, (state) => {
        state.deepGramTranscription = false;
      })
      .addCase(addDeepGramTranscriptionData.rejected, (state) => {
        state.deepGramTranscription = false;
      })
      .addCase(updateConsultationButtonStatusData.pending, (state) => {
        state.updateConsultationButtonLoader = true;
      })
      .addCase(updateConsultationButtonStatusData.fulfilled, (state) => {
        state.updateConsultationButtonLoader = false;
      })
      .addCase(updateConsultationButtonStatusData.rejected, (state) => {
        state.updateConsultationButtonLoader = false;
      })
      .addCase(getPatientConsultationsCountData.pending, (state) => {
        state.isPatientConsultaionCountLoading = true;
      })
      .addCase(getPatientConsultationsCountData.fulfilled, (state, action) => {
        state.isPatientConsultaionCountLoading = false;
        state.patientConsultaionCountData = action?.payload;
      })
      .addCase(getPatientConsultationsCountData.rejected, (state, action) => {
        state.isPatientConsultaionCountLoading = false;
        state.patientConsultaionCountData = [];
      })
      .addCase(getAddressInformationUrlData.pending, (state) => {
        state.addressSearchLoading = true;
      })
      .addCase(getAddressInformationUrlData.fulfilled, (state, action) => {
        state.addressSearchLoading = false;
        state.addressSearchResults = action?.payload || [];
      })
      .addCase(getAddressInformationUrlData.rejected, (state, action) => {
        state.addressSearchLoading = true;
      })
      .addCase(generateAiServiceTemplateData.pending, (state) => {
        state.serviceSummaryLoading = true;
      })
      .addCase(generateAiServiceTemplateData.fulfilled, (state, action) => {
        state.serviceSummaryLoading = false;
        state.serviceSummary = action?.payload || "";
      })
      .addCase(generateAiServiceTemplateData.rejected, (state, action) => {
        state.serviceSummaryLoading = true;
      })
      .addCase(generatePreConsultAiServiceTemplateData.pending, (state) => {
        state.isPreConsultServiceSummaryLoading = true;
      })
      .addCase(
        generatePreConsultAiServiceTemplateData.fulfilled,
        (state, action) => {
          state.isPreConsultServiceSummaryLoading = false;
          state.preConsultServiceSummary = action?.payload || "";
        },
      )
      .addCase(
        generatePreConsultAiServiceTemplateData.rejected,
        (state, action) => {
          state.isPreConsultServiceSummaryLoading = true;
        },
      )
      .addCase(
        getPatientConsultationByConsultationIdData.pending,
        (state, action) => {
          state.showPatientConsultationsLoader = true;
        },
      )
      .addCase(
        getPatientConsultationByConsultationIdData.fulfilled,
        (state, action) => {
          const appResponse = action?.payload;
          if (appResponse) {
            if (appResponse.preConsultationTemplate != null) {
              state.hasPreConsultTab = true;
            }
            state.isConsultationEnabled = false;
            state.selectedPatientConsultation = appResponse;
            state.consultationId = appResponse?.consultationId;
            state.patientTranscription = appResponse?.transcription;
            state.transcript = appResponse?.transcription;
            state.selectedTemplate = appResponse?.template;
            state.signatureDetails = appResponse?.patientConsent;
            state.PatientNotes =
              appResponse?.notes === null ? "" : appResponse?.notes;
            state.consultationPaused =
              appResponse?.consultationStatus === 3 &&
              !!appResponse?.transcription?.trim()
                ? true
                : false;
            state.showPlayPauseBtn =
              appResponse?.consultationStatus === 3 ? true : false;
            if (
              appResponse?.consultationButtonStatus ===
              ConsultationButtonStatus.Manual
            ) {
              state.consultationMediaButtonMode = "manual";
            }
            state.prescriptionCompleted = false;
            state.patientInfoTab = 1;
            state.paymentCompleted = false;
            state.referralCompleted = false;
            state.bookingCompleted = false;
            state.vitalsCompleted = false;
            state.vaccineCompleted = false;
            state.signatureCompleted = false;
            state.isImageDocUploaded = false;
            state.isTreatmenPlanCreated = false;
            // state.patientAIChatMessages = []; // state fix
          }
          state.consultationData = appResponse;
          state.showPatientConsultationsLoader = false;
        },
      )
      .addCase(
        getPatientConsultationByConsultationIdData.rejected,
        (state, action) => {
          state.showPatientConsultationsLoader = false;
        },
      )
      .addCase(getConsultationAuditTimelineData.pending, (state) => {
        state.auditTimelineLoader = true;
      })
      .addCase(getConsultationAuditTimelineData.fulfilled, (state, action) => {
        state.auditTimelineLoader = false;
        state.consultationAuditTimeline = action?.payload || [];
      })
      .addCase(getConsultationAuditTimelineData.rejected, (state, action) => {
        state.auditTimelineLoader = true;
      })
      .addCase(getDoctorsBySearchData.pending, (state) => {})
      .addCase(getDoctorsBySearchData.fulfilled, (state, action) => {
        state.searchedDoctor = action?.payload || null;
      })
      .addCase(getDoctorsBySearchData.rejected, (state, action) => {})
      .addCase(addPatientDocumentsData.pending, (state) => {
        state.patientDocumentsLoader = true;
        state.documentCompleted = false;
      })
      .addCase(addPatientDocumentsData.fulfilled, (state, action) => {
        state.patientDocumentsLoader = false;
        state.documentCompleted = true;
        state.summaryDocumentId = action?.payload || null;
      })
      .addCase(addPatientDocumentsData.rejected, (state, action) => {
        state.patientDocumentsLoader = false;
        state.documentCompleted = false;
      })
      .addCase(getPatientDocumentsData.pending, (state) => {
        state.patientDocumentsLoader = true;
      })
      .addCase(getPatientDocumentsData.fulfilled, (state, action) => {
        state.patientDocumentsLoader = false;
        state.patientDocuments = action?.payload || [];
      })
      .addCase(getPatientDocumentsData.rejected, (state, action) => {
        state.patientDocumentsLoader = false;
      })
      .addCase(renamePatientDocumentData.pending, (state) => {})
      .addCase(renamePatientDocumentData.fulfilled, (state, action) => {})
      .addCase(renamePatientDocumentData.rejected, (state, action) => {})
      .addCase(emailPatientDocumentData.pending, (state, action) => {})
      .addCase(emailPatientDocumentData.fulfilled, (state, action) => {})
      .addCase(emailPatientDocumentData.rejected, (state, action) => {})
      .addCase(deletePatientDocumentData.pending, (state, action) => {})
      .addCase(deletePatientDocumentData.fulfilled, (state, action) => {})
      .addCase(deletePatientDocumentData.rejected, (state, action) => {})
      .addCase(getPatientDocumentByIdData.pending, (state, action) => {
        state.patientDocumentDetailsLoader = true;
      })
      .addCase(getPatientDocumentByIdData.fulfilled, (state, action) => {
        state.patientDocumentDetailsLoader = false;
        state.patientDocumentDetails = action?.payload || {};
      })
      .addCase(getPatientDocumentByIdData.rejected, (state, action) => {
        state.patientDocumentDetailsLoader = false;
      })
      .addCase(getPatientVitalsChartsData.pending, (state, action) => {
        state.filteredPatientsLoader = true;
      })
      .addCase(getPatientVitalsChartsData.fulfilled, (state, action) => {
        state.filteredPatientsLoader = false;
        state.patientVitalsChart = action?.payload;
      })
      .addCase(getPatientVitalsChartsData.rejected, (state, action) => {
        state.filteredPatients = false;
      })
      .addCase(getPatientPrescriptionsByPatientIdData.pending, (state) => {
        state.patientPrescriptions = [];
        state.patientPrescriptionsLoader = true;
      })
      .addCase(
        getPatientPrescriptionsByPatientIdData.fulfilled,
        (state, action) => {
          state.patientPrescriptionsLoader = false;
          state.patientPrescriptions = action?.payload || [];
        },
      )
      .addCase(
        getPatientPrescriptionsByPatientIdData.rejected,
        (state, action) => {
          state.patientPrescriptionsLoader = false;
        },
      )
      .addCase(getPatientActiveConsultationData.pending, (state, action) => {
        state.showActivePatientConsultationsLoader = true;
      })
      .addCase(getPatientActiveConsultationData.fulfilled, (state, action) => {
        state.showActivePatientConsultationsLoader = false;
        state.patientActiveConsultation = action?.payload || [];
      })
      .addCase(getPatientActiveConsultationData.rejected, (state, action) => {
        state.showActivePatientConsultationsLoader = false;
      })
      .addCase(getAllDocumentsByEmailData.pending, (state, action) => {
        state.allDocumentsLoader = true;
      })
      .addCase(getAllDocumentsByEmailData.fulfilled, (state, action) => {
        state.allDocumentsLoader = false;
        state.allDocuments = action?.payload || [];
      })
      .addCase(getAllDocumentsByEmailData.rejected, (state, action) => {
        state.allDocumentsLoader = false;
      })
      .addCase(updateEventStatusData.pending, (state, action) => {
        state.updateEventStatusLoader = true;
      })
      .addCase(updateEventStatusData.fulfilled, (state, action) => {
        state.updateEventStatusLoader = false;
      })
      .addCase(updateEventStatusData.rejected, (state, action) => {
        state.updateEventStatusLoader = false;
      })
      .addCase(getCompanyTagsByCompanyIdData.pending, (state, action) => {
        state.isCompanyTagsLoading = true;
      })
      .addCase(getCompanyTagsByCompanyIdData.fulfilled, (state, action) => {
        state.isCompanyTagsLoading = false;
        state.companyTags = action?.payload;
      })
      .addCase(getCompanyTagsByCompanyIdData.rejected, (state, action) => {
        state.isCompanyTagsLoading = false;
      })
      .addCase(addCompanyTagsData.pending, (state, action) => {
        state.isCompanyTagsLoading = true;
      })
      .addCase(addCompanyTagsData.fulfilled, (state, action) => {
        state.isCompanyTagsLoading = false;
      })
      .addCase(addCompanyTagsData.rejected, (state, action) => {
        state.isCompanyTagsLoading = false;
      })
      .addCase(deleteCompanyTagsData.pending, (state, action) => {
        state.isCompanyTagsLoading = true;
      })
      .addCase(deleteCompanyTagsData.fulfilled, (state, action) => {
        state.isCompanyTagsLoading = false;
      })
      .addCase(deleteCompanyTagsData.rejected, (state, action) => {
        state.isCompanyTagsLoading = false;
      })
      .addCase(getPatientByDemoGraphicsData.pending, (state, action) => {
        state.patientDemoGraphicsloader = true;
      })
      .addCase(getPatientByDemoGraphicsData.fulfilled, (state, action) => {
        state.patientDemoGraphicsloader = false;
      })
      .addCase(getPatientByDemoGraphicsData.rejected, (state, action) => {
        state.patientDemoGraphicsloader = false;
      })
      .addCase(getPatientByNhsNumberData.pending, (state, action) => {
        state.patientDemoGraphicsloader = true;
      })
      .addCase(getPatientByNhsNumberData.fulfilled, (state, action) => {
        state.patientDemoGraphicsloader = false;
      })
      .addCase(getPatientByNhsNumberData.rejected, (state, action) => {
        state.patientDemoGraphicsloader = false;
      })
      .addCase(trackServiceBillingData.pending, (state, action) => {
        state.isServiceBillingLoading = true;
      })
      .addCase(trackServiceBillingData.fulfilled, (state, action) => {
        state.isServiceBillingLoading = false;
      })
      .addCase(trackServiceBillingData.rejected, (state, action) => {
        state.isServiceBillingLoading = false;
      })
      .addCase(summarizeConsultationSummariesData.pending, (state, action) => {
        state.isConsultationPointsLoading = true;
        state.consultationPoints = null; // ✅ Clear previous data
        state.patientSummaryForActions = null; // ✅ Clear any related data
      })
      .addCase(
        summarizeConsultationSummariesData.fulfilled,
        (state, action) => {
          state.consultationPoints = action?.payload;
          state.isConsultationPointsLoading = false;
        },
      )
      .addCase(summarizeConsultationSummariesData.rejected, (state, action) => {
        state.isConsultationPointsLoading = false;
        state.consultationPoints = null; // ✅ Clear on error
      })
      .addCase(sendPatientQuestionnairesData.pending, (state, action) => {
        state.isSendPatientQuestionnairesLoading = true;
      })
      .addCase(sendPatientQuestionnairesData.fulfilled, (state, action) => {
        state.isSendPatientQuestionnairesLoading = false;
      })
      .addCase(sendPatientQuestionnairesData.rejected, (state, action) => {
        state.isSendPatientQuestionnairesLoading = false;
      })
      .addCase(
        getPatientQuestionnairesByPatientyIdData.pending,
        (state, action) => {
          state.isGetPatientQuestionnairesLoading = true;
        },
      )
      .addCase(
        getPatientQuestionnairesByPatientyIdData.fulfilled,
        (state, action) => {
          state.isGetPatientQuestionnairesLoading = false;
          state.patientQuestionnaires = action?.payload;
        },
      )
      .addCase(
        getPatientQuestionnairesByPatientyIdData.rejected,
        (state, action) => {
          state.isGetPatientQuestionnairesLoading = false;
        },
      )
      .addCase(checkAndAddConsultationData.pending, (state, action) => {
        state.isConsultationAddedLoading = true;
      })
      .addCase(checkAndAddConsultationData.fulfilled, (state, action) => {
        state.isConsultationAddedLoading = false;
      })
      .addCase(checkAndAddConsultationData.rejected, (state, action) => {
        state.isConsultationAddedLoading = false;
      })
      .addCase(
        startConsultationFromQuestionnaireData.pending,
        (state, action) => {
          state.isStartConsultationFromQuestionnaireLoading = true;
        },
      )
      .addCase(
        startConsultationFromQuestionnaireData.fulfilled,
        (state, action) => {
          state.patientQuestionnaires = action?.payload;
          state.isStartConsultationFromQuestionnaireLoading = false;
        },
      )
      .addCase(
        startConsultationFromQuestionnaireData.rejected,
        (state, action) => {
          state.isStartConsultationFromQuestionnaireLoading = false;
        },
      )
      .addCase(getPatientsListData.pending, (state) => {
        state.patientListLoader = true;
      })
      .addCase(getPatientsListData.fulfilled, (state, action) => {
        const patientResponse = action?.payload || [];

        if (patientResponse) {
          state.patientList = patientResponse || [];
          if (!Array.isArray(patientResponse)) return [];

          state.mappedPatients = Array.isArray(patientResponse)
            ? patientResponse.map((p) => ({
                id: p.patientID || p._id,
                name: p.patientName || "",
                age:
                  p.age === "" || p.age === null
                    ? calculateAge(p.dob)
                    : Number(p.age),
                dob:
                  p?.dob && p?.dob !== "1900-01-01T00:00:00"
                    ? dayjs(p.dob).format("DD/MM/YYYY")
                    : "",
                address: p.address || "",
                contact: Array.isArray(p.contacts)
                  ? p.contacts.find((c) => c.contactType === 4)?.value || ""
                  : "",
                email: p.email || "",
                tags: p.patientTags || [],
                allergies: Array.isArray(p.allergies)
                  ? p.allergies.map((a) => a.allergyName || "")
                  : [],
                lastConsultation: p.consultation?.lastConsultation ?? "",
                practitioner: p.consultation?.practitioner ?? "",
                isConsultationActive: p.consultation?.status,
                consultationId: p.consultation?.consultationId,
                nhs: p.nhsNumber || "",
                originalPatient: p,
                imported: p.imported !== false,
                pharmacyName: p.pharmacyName || "",
                pharmacyId: p.pharmacyID || "",
              }))
            : [];
        }

        state.patientListLoader = false;
      })
      .addCase(getPatientsListData.rejected, (state, action) => {
        state.patientListLoader = false;
      })
      .addCase(SummarizeConsultationsActionsData.pending, (state, action) => {
        state.isConsultationSummaryLoading = true;
      })
      .addCase(SummarizeConsultationsActionsData.fulfilled, (state, action) => {
        state.patientSummaryForActions = action?.payload;
        state.isConsultationSummaryLoading = false;
      })
      .addCase(SummarizeConsultationsActionsData.rejected, (state, action) => {
        state.isConsultationSummaryLoading = false;
      })
      .addCase(mergePatientDetailsData.pending, (state, action) => {
        state.mergePatientDetailsLoader = true;
      })
      .addCase(mergePatientDetailsData.fulfilled, (state, action) => {
        state.mergePatientDetailsRes = action?.payload;
        state.mergePatientDetailsLoader = false;
      })
      .addCase(mergePatientDetailsData.rejected, (state, action) => {
        state.mergePatientDetailsLoader = false;
      })
      .addCase(getPreConsultationByConsultationIdData.pending, (state) => {
        state.ispreConsultDataLoading = true;
      })
      .addCase(
        getPreConsultationByConsultationIdData.fulfilled,
        (state, action) => {
          state.preConsultData = action?.payload || null;
          state.ispreConsultDataLoading = false;
        },
      )
      .addCase(
        getPreConsultationByConsultationIdData.rejected,
        (state, action) => {
          state.ispreConsultDataLoading = false;
        },
      )
      .addCase(
        getPatientConsultationCountByPatientIdData.pending,
        (state, action) => {
          state.patientConsultationCountLoading = true;
        },
      )
      .addCase(
        getPatientConsultationCountByPatientIdData.fulfilled,
        (state, action) => {
          state.patientConsultationCount = action?.payload || [];
          state.patientConsultationCountLoading = false;
        },
      )
      .addCase(
        getPatientConsultationCountByPatientIdData.rejected,
        (state, action) => {
          state.patientConsultationCountLoading = false;
        },
      )
      .addCase(importMultipleFromTitanData.pending, (state, action) => {
        state.isImportMultipleFromTitanLoading = true;
      })
      .addCase(importMultipleFromTitanData.fulfilled, (state, action) => {
        state.isImportMultipleFromTitanLoading = false;
      })
      .addCase(importMultipleFromTitanData.rejected, (state, action) => {
        state.isImportMultipleFromTitanLoading = false;
      })
      .addCase(getPatientsListV2Data.pending, (state) => {
        state.patientListLoader = true;
        state.filteredPatientsLoader = true;
      })
      .addCase(getPatientsListV2Data.fulfilled, (state, action) => {
        const patientResponse = action?.payload || [];
        state.filteredPatients = patientResponse;

        if (patientResponse) {
          state.patientList = patientResponse || [];
          if (!Array.isArray(patientResponse)) return [];

          state.mappedPatients = Array.isArray(patientResponse)
            ? patientResponse.map((p) => ({
                id: p.patientID || p._id,
                name: p.patientName || "",
                age:
                  p.age === "" || p.age === null
                    ? calculateAge(p.dob)
                    : Number(p.age),
                dob:
                  p?.dob && p?.dob !== "1900-01-01T00:00:00"
                    ? dayjs(p.dob).format("DD/MM/YYYY")
                    : "",
                address: p.address || "",
                contact: Array.isArray(p.contacts)
                  ? p.contacts.find((c) => c.contactType === 4)?.value || ""
                  : "",
                email: p.email || "",
                tags: p.patientTags || [],
                allergies: Array.isArray(p.allergies)
                  ? p.allergies.map((a) => a.allergyName || "")
                  : [],
                lastConsultation: p.consultation?.lastConsultation ?? "",
                practitioner: p.consultation?.practitioner ?? "",
                isConsultationActive: p.consultation?.status,
                consultationId: p.consultation?.consultationId,
                nhs: p.nhsNumber || "",
                originalPatient: p,
                imported: p.imported !== false,
                pharmacyName: p.pharmacyName || "",
                pharmacyId: p.pharmacyID || "",
              }))
            : [];
        }

        state.patientListLoader = false;
        state.filteredPatientsLoader = false;
      })
      .addCase(getPatientsListV2Data.rejected, (state, action) => {
        state.patientListLoader = false;
        state.filteredPatientsLoader = false;
      })
      .addCase(getPatientsListPowerSearchData.pending, (state) => {
        state.filteredPatientsLoader = true;
      })
      .addCase(getPatientsListPowerSearchData.fulfilled, (state, action) => {
        state.filteredPatients = action?.payload || [];
        state.filteredPatientsLoader = false;
      })
      .addCase(getPatientsListPowerSearchData.rejected, (state, action) => {
        state.filteredPatientsLoader = false;
      })
      .addCase(getPaymentAuditByConsultationData.pending, (state) => {
        state.isPaymentAuditDataLoading = true;
      })
      .addCase(getPaymentAuditByConsultationData.fulfilled, (state, action) => {
        state.paymentAuditData = action?.payload || null;
        state.isPaymentAuditDataLoading = false;
      })
      .addCase(getPaymentAuditByConsultationData.rejected, (state, action) => {
        state.isPaymentAuditDataLoading = false;
      })
      .addCase(getPatientConsentSignatureData.pending, (state) => {
        state.isgetPatientConsentSignatureLoading = true;
      })
      .addCase(getPatientConsentSignatureData.fulfilled, (state, action) => {
        state.isgetPatientConsentSignatureLoading = false;
        state.patientConsentSignature = action?.payload || "";
      })
      .addCase(getPatientConsentSignatureData.rejected, (state, action) => {
        state.isgetPatientConsentSignatureLoading = false;
      })
      .addCase(getReferalLetterByFilePathData.pending, (state) => {
        state.isSummaryLetterLoading = true;
      })
      .addCase(getReferalLetterByFilePathData.fulfilled, (state, action) => {
        state.isSummaryLetterLoading = false;
        state.patientReferalLetter = action?.payload || "";
      })
      .addCase(getReferalLetterByFilePathData.rejected, (state, action) => {
        state.isSummaryLetterLoading = false;
      })
      .addCase(getPatientDocumentsByConsultationData.pending, (state) => {
        state.patientDocumentsLoader = true;
      })
      .addCase(
        getPatientDocumentsByConsultationData.fulfilled,
        (state, action) => {
          state.patientDocumentsLoader = false;
          state.patientDocumentsConultaion = action?.payload || [];
        },
      )
      .addCase(
        getPatientDocumentsByConsultationData.rejected,
        (state, action) => {
          state.patientDocumentsLoader = false;
        },
      )
      .addCase(getPatientVaccinationByPatientIdData.pending, (state) => {
        state.isPatientVaccinationsLoading = true;
      })
      .addCase(
        getPatientVaccinationByPatientIdData.fulfilled,
        (state, action) => {
          state.isPatientVaccinationsLoading = false;
          state.patientVaccinations = action?.payload || null;
        },
      )
      .addCase(
        getPatientVaccinationByPatientIdData.rejected,
        (state, action) => {
          state.isPatientVaccinationsLoading = false;
        },
      )
      .addCase(updatePatientEthnicityData.pending, (state) => {
        state.addPatientVitalsLoader = true;
      })
      .addCase(updatePatientEthnicityData.fulfilled, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(updatePatientEthnicityData.rejected, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(generateVideoUploadUrlData.pending, (state) => {})
      .addCase(generateVideoUploadUrlData.fulfilled, (state, action) => {})
      .addCase(generateVideoUploadUrlData.rejected, (state, action) => {})
      // getAllDestinationsData
      .addCase(getAllDestinationsData.pending, (state) => {
        state.isTravelDestinationsLoading = true;
      })
      .addCase(getAllDestinationsData.fulfilled, (state, action) => {
        state.isTravelDestinationsLoading = false;
        if (action.payload) {
          state.travelDestinations = action.payload;
        }
      })
      .addCase(getAllDestinationsData.rejected, (state) => {
        state.isTravelDestinationsLoading = false;
      })
      // getTravelOutbreaksData
      .addCase(getTravelOutbreaksData.pending, (state) => {
        state.isTravelOutbreaksLoading = true;
      })
      .addCase(getTravelOutbreaksData.fulfilled, (state, action) => {
        state.isTravelOutbreaksLoading = false;
        if (action.payload) {
          state.travelOutbreaks = action.payload;
        }
      })
      .addCase(getTravelOutbreaksData.rejected, (state) => {
        state.isTravelOutbreaksLoading = false;
      })
      .addCase(updateTaskActionStatusData.pending, (state) => {
        state.addPatientVitalsLoader = true;
      })
      .addCase(updateTaskActionStatusData.fulfilled, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(updateTaskActionStatusData.rejected, (state, action) => {
        state.addPatientVitalsLoader = false;
      })
      .addCase(searchSurgeryData.pending, (state) => {
        state.searchedSurgeriesLoading = true;
      })
      .addCase(searchSurgeryData.fulfilled, (state, action) => {
        state.searchedSurgeries = action?.payload || [];
        state.searchedSurgeriesLoading = false;
      })
      .addCase(searchSurgeryData.rejected, (state, action) => {
        state.searchedSurgeries = [];
        state.searchedSurgeriesLoading = false;
      })
      .addCase(getSurgeryByIdData.pending, (state) => {
        state.isSurgeryLoading = true;
      })
      .addCase(getSurgeryByIdData.fulfilled, (state, action) => {
        state.isSurgeryLoading = false;
        state.surgeryData = action?.payload || null;
      })
      .addCase(getSurgeryByIdData.rejected, (state, action) => {
        state.isSurgeryLoading = false;
      })
      .addCase(accessRecordData.pending, (state) => {
        state.isAccessRecordLoading = true;
      })
      .addCase(accessRecordData.fulfilled, (state, action) => {
        state.isAccessRecordLoading = false;
        state.accessRecordData = action?.payload || null;
      })
      .addCase(accessRecordData.rejected, (state, action) => {
        state.isAccessRecordLoading = false;
      })
      .addCase(parseAbpmReportData.pending, (state) => {
        state.isParseAbpmReportLoading = true;
      })
      .addCase(parseAbpmReportData.fulfilled, (state, action) => {
        state.isParseAbpmReportLoading = false;
        state.abpmReadings = action?.payload || null;
      })
      .addCase(parseAbpmReportData.rejected, (state, action) => {
        state.isParseAbpmReportLoading = false;
      })
      .addCase(updatePatientSurgeryData.pending, (state) => {
        state.isUpdatePatientSurgeryLoading = true;
      })
      .addCase(updatePatientSurgeryData.fulfilled, (state, action) => {
        state.isUpdatePatientSurgeryLoading = false;
        state.patientSurgeryData = action?.payload || null;
      })
      .addCase(updatePatientSurgeryData.rejected, (state, action) => {
        state.isUpdatePatientSurgeryLoading = false;
      })

      .addCase(addNhsServiceClaimData.pending, (state) => {
        state.isAddNhsServiceClaimLoading = true;
      })
      .addCase(addNhsServiceClaimData.fulfilled, (state, action) => {
        state.isAddNhsServiceClaimLoading = false;
        state.addNhsServiceClaimRes = action?.payload || null;
      })
      .addCase(addNhsServiceClaimData.rejected, (state, action) => {
        state.isAddNhsServiceClaimLoading = false;
      });
  },
});

export const {
  setIsSelectedPatientData,
  setSelectedPatientDetailsData,
  setIsPatientDashboardData,
  setIsConsultationTabData,
  setConsultationStartedData,
  setPatientDashboardTabData,
  setOpenAddTemplateData,
  setShowStartConsultationModalData,
  showConsultationTypeModalData,
  setShowPrescriptionPreviewModalData,
  setPrescriptionImageBase64Data,
  setShowVaccinationPreviewModalData,
  setVaccinationImageBase64Data,
  setShowVaccineConfirmationModalData,
  setPatientTranscriptionData,
  setPatientTabSwitcherData,
  setShowAddVitalsModalData,
  setpatientSummaryData,
  setpatientSummaryArrayData,
  setpatientCurrentSummaryArrayData,
  setpatientSummaryLoaderData,
  setSelectedPharmacyIdData,
  setSelectedPatientIdData,
  setPatientAiTemplateData,
  setIsSummaryGeneratedData,
  setReferralLetterData,
  setTogglePatientPanelOneData,
  setFirstPatientPanelTitleData,
  setTogglePatientPanelTwoData,
  setSecondPatientPanelTitleData,
  setShowAddAllergiessModalData,
  setShowAddPatientConditionModalData,
  setShowAddPatientMedicationModalData,
  setPatientChatAnswersLoaderData,
  setPatientAIChatMessagesData,
  setTemplateStructureData,
  setConsultationIdData,
  incrementPrescriptionCompleted,
  incrementPaymentCompleted,
  incrementReferralCompleted,
  incrementBookingCompleted,
  incrementVitalsCompleted,
  setVaccineCompleted,
  incrementVaccineCompleted,
  resetPatientQuickActionsState,
  setShowPatientDetailsEditModal,
  setShowPreviousConsultationsModalData,
  setPatientConsultationsData,
  setIsChatReferralLetterData,
  setChatBotReferralLetterData,
  setChatQuestionsData,
  setIsChatBotLetterGeneratedData,
  setPrevConsultationsDetailDataData,
  setDemDXTemplatesData,
  addPatientAIChatMessage,
  updateVitalAIChatMessage,
  updateAppointmentAIChatMessage,
  setAiChatSuccessMessagesData,
  setOpenPatientForm,
  setNewPatientFormDefaultsData,
  setShowNoPatientCardData,
  setSelectedPatientConsultationData,
  setIsConsultationEnabledData,
  setIsDemDXTemplateData,
  setIsSummaryStreamingData,
  setShowPatientReferralLetterModal,
  setShowPatientPrescriptionModal,
  setPatientPrescriptionData,
  setShowEditAiTemplateModal,
  setIsDemDXGlobalCheckData,
  setDemDxSummaryData,
  setIsDemDxActiveData,
  setStreamedTextData,
  setDemDXForChatData,
  setisSummaryEnabledData,
  setIsShowPatientConsultationsLoader,
  setDemDXPatientData,
  setIsCallStartedData,
  openVitalsModal,
  closeVitalsModal,
  setOpenDeleteVitalsModal,
  setIsPatientDetailsLoadingData,
  setConsultationEndedData,
  setPatientAllergyToEditData,
  setPatientAllergyToDeleteData,
  setPatientConditionRelatedToEditData,
  setPatientConditionRelatedToDeleteData,
  setPatientMedicationsToEditData,
  setPatientMedicationsToDeleteData,
  setIsFinalSummaryData,
  setPatientNotesData,
  setPatientConsultationMediaButtonModeData,
  setDemDxSummaryTextData,
  setIsNotesExpandedData,
  setTranscriptData,
  setConsultationPausedData,
  incrementSignatureCompleted,
  setShowAddPatientModalData,
  setHasPreConsultTabData,
  setConsultationStopAfterRefreshData,
  setShowPlayPauseBtnData,
  setFreeTypeModeData,
  setOpenSignatureDialogData,
  setSignatureDetailsData,
  setIsLocallyCompletedData,
  setPreConsultationTemplateData,
  addAllergyOptimisticData,
  removeAllergyByIdData,
  setIsPatientListLoaderData,
  setVitalsDetailsData,
  setVaccineDetailsData,
  setOpenVaccineDialogData,
  setBookingDetailsData,
  setOpenBookingDialogData,
  setOpenRefDialogData,
  setLetterDetailsData,
  setPreConsultationTranscriptionData,
  setPreConsultAddtoSummaryData,
  setSearchedDoctorsData,
  setSearchedSurgeriesData,
  setHasPreConsultData,
  setisHandleStartConsultationData,
  setConsultationAuditTimelineData,
  setOpenPrescriptionDialogData,
  setPrescriptionDetailsData,
  setDynamicPrescriptionsData,
  setPrescriptionIdData,
  setIsPrescriptionUpdateData,
  setSelectedPrescriptionCategoryData,
  setQuickActionsTabSwitchData,
  setSelectedCompanyTagsData,
  setSelectedConsultationData,
  setPatientSummaryForActionsData,
  setPreConsultImagePreviewData,
  setShowPreConsultImagePreviewModalData,
  setFilteredPatientsData,
  setComingFromPatientListViewData,
  setPaymentAuditData,
  setPreConsultData,
  setPatientConsentSignatureData,
  setNhs111FormData,
  setNhs111PrescriptionsData,
  setNhs111EmergencySupplyMedicationsData,
  setConsultationServiceCodeData,
  setShowMultipleVaccineCertificatePreviewData,
  setMultipleVaccinationImageData,
  setViewOpenData,
  setisManualSubmitedData,
  setImageDocsDetailsData,
  incrementImageUploadCompleted,
  setGeneratedVaccinationCertificateData,
  setTravelDestinationsData,
  setConsultationsState,
  setSnomedCodesData,
  clearConsultationsState,
  resetSelectedConsultation,
  incrementTreatmentPlanCompleted,
  setTreatmentPlanDetailssData,
  updateTreatmentPlanAIChatMessage,
  setShowReferralLetterDialogData,
  removeTreatmentPlanAIChatMessage,
  setNhsContraceptionFormData,
  setNhsSinusitisFormData,
  setNhsUtiFormData,
  setNhsSoreThroatFormData,
  setNhsImpetigoFormData,
  setNhsInsectBitesFormData,
  setNhsShinglesFormData,
  setNhsAomFormData,
  setNhsAhtFormData,
  setShowPathwayCompletionModalData,
  setPendingCalculatorIdData,
  setHypertensionInitialFormData,
  setHypertensionABPMFittingFormData,
  setSurgeryData,
  setisConsultationDataLoadingData,
  setHypertensionABPMFollowupFormData,
  setAccessRecordData,
  setCompletedTasksForConsultationData,
  toggleCompletedTaskForConsultationData,
} = patientSlice.actions;

export default patientSlice.reducer;
